import striptags from "striptags";
import {
    date2DDMMYYYY, date2HHMM,
    date2Iso,
    date2Mysql,
    date2MysqlFull,
    iso2Date,
    iso2DDMMYYYY,
    iso2HHMM,
    mysql2Date
} from "@/utils/date";
import Config from "@/config";
import {ACTIONS} from "@/utils/comment";
import store from "@/store";
import router from "@/router";
import {findPs, pContent} from "@/utils/p";
import {end, md5} from "@/utils/string";
import {parseContextIds} from "@/utils/context";
import {fullContextItem, jointContexts, PRESETS} from "@/utils/pick";
import Vue from "vue";
import {flatArray, parentsOf} from "@/utils/utils";
import storage from "@/utils/storage";
import {extraTaskHolders} from "@/utils/taskHolders";
import {initPicksInArea, initFavoriteUsersInArea} from "@/utils/area";
import {sortByAuth, insertGroupByActivity} from "@/utils/group";

export const ROLES = {
    CREATOR: {
        id: "creator",
        name: "Создатель",
        isFixed: true,
    },
    ADMINISTRATOR: {
        id: "admin",
        name: "Администратор",
        icon: "mdi-pencil"
    },
    USER: {
        id: "user",
        name: "Участник",
        icon: "mdi-account"
    },
    READER: {
        id: "reader",
        name: "Читатель",
        icon: "mdi-eye"
    }
};

export const TABS = {
    ACTUAL: "actual",
    NOTES: "notes",
    DELAYED: "delayed",
    DONE: "done",
    DELETED: "deleted",
    TEMPLATES: "templates",
};

export const tabs = [
    {
        id: "actual",
        isActual: true,
        icon: "mdi-rocket-launch-outline",
        title: "Актуальные задачи",
        label: "В работе",
        //withTodos: true,
        contextCountProp: "countActualTasks",
        isApplicableForSearch: true,
        isMatching: item => item.isActive,
    }, {
        id: "notes",
        icon: "mdi-pin-outline",
        title: "Заметки",
        label: "Заметки",
        //withTodos: true,
        contextCountProp: "countNotes",
        isApplicableForSearch: true,
        isMatching: item => item.isActive && item.isNote,
    }, {
        id: "delayed",
        icon: "mdi-timer-outline",
        title: "Задачи на паузе",
        label: "На паузе",
        //withTodos: true,
        contextCountProp: "countDelayedTasks",
        isApplicableForSearch: true,
        isMatching: item => !item.deletedAt && !item.doneAt && (!!item.delayedTill || item.isDelayed || !!item.deferredAt),
    }, {
        id: "done",
        icon: "mdi-check",
        title: "Выполненные задачи",
        label: "Выполненные",
        //withTodos: true,
        contextCountProp: "countDoneTasks",
        sort: (items) => {
            items = [...items];
            sortByUpdated(items);
            return items;
        },
        isApplicableForSearch: true,
        isMatching: item => !!item.doneAt,
    },
    {
        id: "templates",
        icon: "mdi-view-grid-plus-outline",
        title: "Шаблоны",
        label: "Шаблоны",
        //withTodos: true,
        contextCountProp: "countTemplates",
        isApplicableForSearch: true,
        isApplicableForList: true,
        isMatching: item => !!item.isTemplate,
    },
    {
        id: "deleted",
        icon: "mdi-trash-can-outline",
        title: "Удаленные задачи",
        label: "Корзина",
        //withTodos: true,
        contextCountProp: "countDeletedTasks",
        sort: (items) => {
            items = [...items];
            sortByUpdated(items);
            return items;
        },
        isApplicableForSearch: true,
        isApplicableForList: false,
        isMatching: item => !!item.deletedAt,
    },
];

export const SORT_TYPES = {
    PRIO: "prio",
    SMART: "smart",
    UPDATED: "updated",
    ACTIVITY: "activity",
    DELETED: "deleted",
    ALPHABET: "alphabet",
    USER: "user",
    INDEX: "index",
};

export const sortTypes = [
    {
        id: SORT_TYPES.INDEX,
        icon: "sort-ascending",
        title: "Сортировать по важности",
        label: "По важности",
        //isSortable: true,
        sort: (items) => {
            sortByIndex(items);
        },
        isSortable: true,
    },
    {
        id: SORT_TYPES.SMART,
        icon: "sort-ascending",
        title: "Сортировать по важности",
        label: "По важности",
        //isSortable: true,
        sort: (items) => {
            sortBySmart(items);
        },
        isSortable: true,
    },
    {
        id: SORT_TYPES.PRIO,
        icon: "mdi-sort-numeric-ascending",
        title: "Сортировать по приоритету",
        label: "По приоритету",
        //isSortable: true,
        sort: (items) => {
            items = [...items];
            sortByPrio(items);
            return items;
        },
        isSortable: true,
    },
    {
        id: SORT_TYPES.UPDATED,
        icon: "mdi-sort-clock-ascending-outline",
        title: "Сортировать по дате изменения",
        label: "По дате изменения",
        sort: (items) => {
            items = [...items];
            sortByUpdated(items);
            return items;
        }
    },
    /*{
        id: SORT_TYPES.DELETED,
        icon: "mdi-sort-clock-ascending-outline",
        title: "Сортировать по дате удаления",
        label: "По дате удаления",
        sort: (items) => {
            items = [...items];
            sortByDeleted(items);
            return items;
        }
    },*/
    {
        id: SORT_TYPES.ALPHABET,
        icon: "mdi-sort-alphabetical-ascending",
        title: "Сортировать по алфавиту",
        label: "По алфавиту",
        sort: (items) => {
            items = [...items];
            sortByAlphabet(items);
            return items;
        }
    },
    {
        id: SORT_TYPES.USER,
        icon: "mdi-sort",
        title: "Ручная сортировка",
        label: "Ручная сортировка",
        isSortable: true,
    }
];

export const colors = {
    TASK_TEMPLATE: "purple lighten-1",
    TASK_TEMPLATE_STOPPED: "purple lighten-3",
    TASK_DEADLINE: "warning",
    TASK_DEADLINE_OVERDUE: "error",
    TASK_PRIO: "red",
    TASK_DONE: "success",
    TASK_DELAYED: "blue",
    TASK_DEFERRED: "blue",
    TASK_DELETED: "grey",
    TASK_WEAK: "grey lighten-2",
    NEW: "success",
};

export const STATUSES = {
    DELETED: "deleted",
    DONE: "done",
    PRIO: "prio",
    DEFERRED: "deferred",
    DELAYED: "delayed",
    DEADLINE: "deadline",
    TEMPLATE: "template",
    REPEATED: "repeated",
    TEMPLATED: "templated",
    FOLLOWED: "followed",
    REMINDER: "reminder",
    HIDDEN: "hidden",
    HAS_REMINDER: "hasReminder",
};

/**
 * Текст статуса повторений: расписание и ближайшее повторение
 * @param item задача
 * @param prefix начало фразы
 */
export const repeatStatusText = (item, prefix) => {
    let repeatDays = item.repeatDays;
    if (typeof repeatDays === "string") {
        try {
            repeatDays = JSON.parse(repeatDays);
        } catch (e) {
        }
    }

    let repeatText = "";
    if (item.repeat === "hourly") {
        repeatText = "ежечасно";
    } else if (item.repeat === "daily") {
        repeatText = "ежедневно";
    } else if (item.repeat === "weekly" && repeatDays) {
        repeatText = "по " + Config.DAY_LABELS.filter((el, index) => repeatDays.includes(index)).join(", ");
    } else if (item.repeat === "monthly" && repeatDays) {
        repeatText = "в определенные дни месяца";
    } else if (item.repeat === "yearly" && repeatDays) {
        repeatText = "в определенные дни года";
    } else return "Режим повторений не установлен";

    let nearestRepeat = "";
    if (item.repeatAt) {
        nearestRepeat = ", следующее повторение: " + iso2DDMMYYYY(item.repeatAt) + " " + iso2HHMM(item.repeatAt);
    }
    return prefix + " " + repeatText + nearestRepeat;
};

export const statuses = [
    {
        id: STATUSES.DELETED,
        icon: "mdi-trash-can-outline",
        //type: "info",
        color: "grey lighten-4 grey--text",
        //dark: true,
        appliesTo: item => isTaskDeleted(item),
        text: (item) => {
            let deletedAt = item.deletedAt;
            if (deletedAt instanceof Date) deletedAt = date2MysqlFull(deletedAt);
            return "Задача удалена " + iso2DDMMYYYY(deletedAt) + " в " + iso2HHMM(deletedAt);
        },
        onClick: async (item, component) => {
            await component.restoreTask(item);
        }
    },
    {
        id: STATUSES.DONE,
        icon: "mdi-check",
        //type: "success",
        color: "success",
        dark: true,
        appliesTo: item => isTaskDone(item) && !isTaskDeleted(item)
            && !isTaskTemplate(item) && !isTaskReminder(item),
        text: (item) => {
            let doneAt = item.doneAt;
            if (doneAt instanceof Date) doneAt = date2MysqlFull(doneAt);
            return "Задача выполнена " + iso2DDMMYYYY(doneAt) + " в " + iso2HHMM(doneAt);
        },
        onClick: async (item, component) => {
            if (item.totalStages > 1 && item.contentId) {
                const selectedStage = store.state.page.task.stages?.find(el => el.contentId === item.contentId);
                await component.toggleTaskStageItemDone(item, selectedStage);
                return;
            }
            await component.toggleTaskDone(item, false);

            /*store.dispatch("task/update", {
                taskId: item.id,
                params: {
                    doneAt: null,
                }
            });*/
        }
    },
    /*{
        id: STATUSES.PRIO,
        icon: "mdi-fire",
        type: "error",
        appliesTo: item => item.prio,
        text: () => "Важная задача!",
        onClick: item => {
            store.dispatch("task/update", {
                taskAuth: item.auth,
                params: {
                    "prio": !item.prio
                }
            });
        }
    },*/
    /*{
        id: STATUSES.DEFERRED,
        icon: "mdi-skip-next-outline",
        type: "info",
        color: "primary",
        dark: true,
        appliesTo: item => isTaskDeferred(item) && !isTaskDone(item),
        text: (item) => {
            //return "Задача пропущена по причине: "+item.deferReason;
            return "Задача пропущена";//item.deferReason;
        },
        onClick: item => {
            store.dispatch("task/update", {
                taskId: item.id,
                params: {
                    deferredAt: null,
                }
            });
        }
    },*/
    {
        id: STATUSES.DELAYED,
        icon: "mdi-timer-outline",
        //type: "info",
        color: "primary",
        dark: true,
        appliesTo: item => isTaskPostponed(item) && !isTaskDone(item)
            && !isTaskDeleted(item) && !isTaskReminder(item),
        text: (item) => {
            let text, suffix;
            //text = "Задача запланирована"
            //suffix = delayedTillText(item);
            if (isTaskDeferred(item)) text = item.deferReason;//"Задача отложена";
            else {
                text = "Задача отложена"
                suffix = delayedTillText(item);
            }
            // else text += " бессрочно";
            return text + (suffix ? " " + suffix : "");
        },
        onClick: item => {
            store.dispatch("task/dialog", {
                dialog: "dialogTaskDelay",
                item,
            });
        }
    },
    {
        id: STATUSES.DEADLINE,
        icon: "mdi-clock-time-eight-outline",
        color: (item) => deadlineTextAndCss(item).color,
        dark: true,
        light: (item) => {
            if (item.isTemplate) return true;
            const date = iso2Date(item.deadline);
            date.setDate(date.getDate() + 1);
            const now = new Date();
            return date > now;
        },
        appliesTo: item => (item.deadline || (isTaskWithDeadlineDays(item) && item.deadlineDays)) && !isTaskDone(item) && !isTaskDeleted(item),
        text: item => {
            return deadlineTextAndCss(item).text;
            /*if (item.isTemplate) return "Дедлайн устанавливается в " + deadlineTextAndCss(item).text;
            else {
                const date = iso2Date(item.deadline);
                date.setDate(date.getDate() + 1);
                const now = new Date();
                let overdue = date < now ? "просрочен " : "";
                return "Дедлайн " + overdue + deadlineTextAndCss(item).text;
            }*/
        },
        onClick: async (item, component) => {
            await component.showDialogTaskDeadline(item);
        }
    },
    {
        id: STATUSES.TEMPLATE,
        icon: "mdi-view-grid-plus-outline",
        // у шаблона doneAt - пауза: новые копии не создаются
        color: item => (item.doneAt || !item.repeat) ? colors.TASK_TEMPLATE_STOPPED : colors.TASK_TEMPLATE,
        dark: true,
        appliesTo: item => !!item.isTemplate,
        text(item) {
            if (item.isDone || item.doneAt) return "Копирование приостановлено";
            return repeatStatusText(item, "Шаблон создает копии");
        },
        onClick: item => {
            store.dispatch("task/dialogTemplate", {
                item,
            });
        }
    },
    {
        id: STATUSES.REPEATED,
        icon: "mdi-repeat",
        // у повторяющейся задачи (не шаблон) doneAt - штатное ожидание следующего появления, а не пауза
        color: () => colors.TASK_TEMPLATE,
        dark: true,
        appliesTo: item => isTaskRepeated(item),
        text(item) {
            return repeatStatusText(item, "Задача повторяется");
        },
        onClick: item => {
            store.dispatch("task/dialogTemplate", {
                item,
            });
        }
    },
    {
        id: STATUSES.TEMPLATED,
        icon: "mdi-view-grid-plus-outline",
        color: "grey lighten-1",
        dark: true,
        //dark: false,
        //msg: "поставил отметку 'Важно!'",
        appliesTo: item => !!item.templateId,// && !isTaskDone(item) && !isTaskDeleted(item),
        text(item) {
            if (!item.templateId) return null;

            const template = store.state.page.task.template;
            if (template) {
                return "Задача создана из шаблона \"" + template.title + "\"";
            } else return "Задача создана из шаблона";//+clearName(template.name);
        },
        to: item => {
            const templateItem = store.state.page.task.templateItem;
            const templateNavPaths = store.state.page.task.templateNavPaths;
            if (templateItem?.id) {
                const contextIdChain = templateNavPaths ? templateNavPaths[0]?.map(el => el.id).join(Config.CONTEXT_ID_CHAIN_SEP) : personalGroup()?.id;
                return {
                    name: "context-task",
                    params: {contextId: contextIdChain, taskId: templateItem.id}
                };
            }
        },
        onClose(item, component) {
            //console.log("close");
            component.do("task/update", {
                taskId: item.id,
                params: {
                    templateId: null
                }
            });
        },
    },
    /*{
        id: STATUSES.FOLLOWED,
        icon: "mdi-eye-outline",
        color: "orange",
        dark: true,
        appliesTo: (item, taskSet, user) => {
            //console.log("navPaths",taskSet.navPaths);
            const contextTaskInUserContext = taskSet.contextTasks?.find(el => el.contextId === user.id);
            /!*const userContexts = taskSet.navPaths.map(navPath=>navPath[navPath.length-1]).filter(x=>{
                console.log("x", x);
                return x.isUser && x.id === user.id;
            });// contextTasks?.find(el=>el.,
            console.log("USER CONTEXTS", userContexts);*!/
            //console.log("USER CONTEXT TASK", contextTaskInUserContext);
            return !!contextTaskInUserContext?.followAt;
        },
        text(item) {
            return "Вы отслеживаете данную задачу";
        },
        actions: [
            {
                text: "Вернуться позже",
                icon: "mdi-skip-next-outline",
                onClick: (item, component) => {
                    //console.log("click on btn!");
                    const followAt = new Date();
                    followAt.setHours(followAt.getHours() + 24);
                    component.followTask(item, followAt);
                }
            },
            {
                text: "Не отслеживать",
                icon: "mdi-eye-off-outline",
                onClick: (item, component) => {
                    component.unfollowTask(item);
                }
            }
        ]
    },*/
    {
        id: STATUSES.REMINDER,
        icon: "mdi-information-outline",
        color: item => isTaskDone(item) || isTaskDelayed(item) ? "grey" : "orange",
        dark: true,
        appliesTo: (item, taskSet, user) => {
            return isTaskReminder(item);
        },
        text(item) {
            return "Напоминание"
                + (isTaskDone(item) ? " (прочитано)" : "")
                + (isTaskDelayed(item) ? " (отложено " + delayedTillText(item) + ")" : "")
            // о задаче \""+(item.relatedTitle || item.title)+"\"";
        },/*
        actions: [
            {
                text: "Вернуться позже",
                icon: "mdi-skip-next-outline",
                onClick: (item, component) => {
                    //console.log("click on btn!");
                    const followAt = new Date();
                    followAt.setHours(followAt.getHours() + 24);
                    component.followTask(item, followAt);
                }
            },
            {
                text: "Не отслеживать",
                icon: "mdi-eye-off-outline",
                onClick: (item, component) => {
                    component.unfollowTask(item);
                }
            }
        ]*/
    },
    {
        id: STATUSES.HIDDEN,
        icon: "mdi-eye-off-outline",
        color: "blue",
        dark: true,
        appliesTo: (item, taskSet, user) => {
            return isTaskHidden(item);
        },
        text: "Задача скрыта в списке задач",
        actions: [
            {
                text: "Показать",
                icon: "mdi-eye-outline",
                onClick: (item, component) => {
                    component.do("task/update", {
                        taskId: item.id,
                        params: {isHidden: false},
                    });
                }
            },
        ]
    },
];

export const PRIOS = {
    REMINDER: 20,
    URGENT: 10,
    IMPORTANT: 8,
    FOCUS: 3,
    NONE: 0,    // @deprecated, alias NORMAL
    NORMAL: 0,
    NOTE: -2,
    COMMENT: -10,

    // special
    HIDDEN: -60,
    DEADLINE: -50,    // должно совпадать с Prio.Deadline на бэкенде
    DELAYED: -90,
    DONE: -98,
    DELETED: -99,
    FOLDER: -127,

    // @deprecated - should not be used anymore... virtual, unrestorable
    OBSOLETE_DELAYED: -2,
    STAGE: -70,
    DEFERRED: -80,
};

/**
 * Запись из prios по значению prio. Вычисляется лениво (во время вызова), т.к. используется внутри самих prios.
 * @param prio
 */
const prioEntryOf = (prio) => prios.find(el => el.prio === prio);

/**
 * Проверяет, что задача уже первая среди задач своей "корзины" приоритета (по индексу в контексте).
 * @param item
 * @param siblings - полный (нефильтрованный) список задач контекста
 * @param prioEntry - запись из prios, чей appliesTo() определяет принадлежность к корзине
 */
const isFirstInPrioBucket = (item, siblings, prioEntry) => {
    const bucket = siblings.filter(el => prioEntry.appliesTo(el));
    // сортируем копию: sortByIndex() сортирует массив на месте
    sortByIndex(bucket);
    return bucket[0]?.id === item.id;
};

export const prios = [
    {
        prio: null,
        label: "Доступ",
        labels: "Доступ",
        title: "Доступ к задаче закрыт",
        icon: "mdi-lock-outline",
        color: "grey",
        visibleTo: item => false,
        appliesTo: (item) => {
            return !hasSomeAccessToTask(item);
        }
    },
    {
        prio: null,
        isSortable: false,
        label: "Запросить доступ",
        labels: "Запросить доступ",
        icon: "mdi-lock-open-variant-outline",
        color: "green",
        visibleTo: item => !hasSomeAccessToTask(item),
        appliesTo: item => false,
        onSelect: async (item, component) => {
            await component.requestAccessToTaskId(item.id);
            return true;    // true means update action already done
        }
    },
    {
        prio: null,
        isSortable: false,
        label: "Запросить доступ на редактирование",
        labels: "Запросить доступ на редактирование",
        icon: "mdi-pencil-outline",
        color: "green",
        visibleTo: item => !hasFullAccessToTask(item) && hasSomeAccessToTask(item),
        appliesTo: item => false,
        onSelect: async (item, component) => {
            await component.requestAccessToTaskId(item.id, true);
            return true;    // true means update action already done
        }
    },
    {
        prio: null,
        isSortable: false,
        label: "Не активно",
        labels: "Не активно",
        icon: "mdi-minus",
        color: "grey",
        visibleTo: item => false,
        appliesTo: item => isTaskInactive(item) && !isTaskDeleted(item) && !isTaskDone(item) && !isTaskDeferred(item) && !isTaskDelayed(item),
    },
    {
        prio: null,
        isSortable: false,
        label: "Вернуть",
        labels: "Вернуть",
        icon: "mdi-arrow-u-left-top",
        color: "grey",
        visibleTo: item => isTaskPostponed(item) || isTaskDone(item) || isTaskDeleted(item),
        appliesTo: item => false,
        /*onClick: async (item) => {
            console.log("ON CLICK STAGE", item.parent);
            if (item.parentId) {
                //await router.push({name: "task", params: {taskId: item.parentId}});
                routeToTaskContext(item);
            }
            return false;
        },*/
        onSelect: async (item, component) => {
            //console.log("SELECTED prio deleted for", item);
            await component.restoreTask(item);
            return true;    // true means update action already done
        }
    },
    {
        prio: PRIOS.REMINDER,
        isSortable: true,
        label: "Напоминание",
        labels: "Напоминания",
        icon: "mdi-information",
        color: "orange",
        visibleTo: item => false,
        appliesTo: item => item.prio === PRIOS.REMINDER,
    },
    {
        // for multi staged task
        prio: PRIOS.DONE,
        isSortable: false,
        label: (item, component) => component.doneTitleOf(item),
        labels: "Выполненные",
        icon: (item, component) => component.doneIconOf(item),
        color: "success",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskDone(item) && !isTaskDeleted(item) && item.totalStages > 1,
        appliesTo: item => false,
        onSelect: async (item, component) => {
            /*console.log("SELECTED stage++", item.activeStage);
            await store.dispatch("task/update", {
                taskId: item.id,
                params: {
                    activeStage: item.activeStage + 1
                }
            });*/
            //await store.dispatch("task/toggleDone", {item});
            const selectedStage = store.state.page.task.stages?.find(el => el.contentId === item.contentId);
            await component.toggleTaskStageItemDone(item, selectedStage);
            return true;    // true means update action already done
        }
    },
    {
        // for single stage task
        prio: PRIOS.DONE,
        isSortable: true,
        filterType: "done",
        label: (item) => {
            if (isTaskReminder(item)) return "Прочитано";
            return "Готово";
        },
        labels: "Выполненные",
        icon: "mdi-check",
        color: "success",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskDone(item) && !isTaskDeleted(item) && item.totalStages <= 1,
        appliesTo: item => isTaskDone(item) && !isTaskDeleted(item),
        onSelect: async (item, component) => {
            //console.log("SELECTED prio done for", item);
            await component.toggleTaskDone(item);
            return true;    // true means update action already done
        }
    },
    {
        prio: PRIOS.DELAYED,
        isSortable: true,
        filterType: "postponed",
        label: item => {
            if (isTaskReminder(item)) {
                return "Напомнить позже";//isTaskPostponed(item) ? "Напомнить позже" : "Напомнить"
            }
            return isTaskPostponed(item) ? "Отложено" : "Отложить"
        },
        labels: "Отложенные",
        title: "Отложено",
        icon: "mdi-timer-sand",
        color: "blue",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskDone(item) && !isTaskDeleted(item) && !isTaskTemplate(item),
        appliesTo: item => isTaskPostponed(item) && !isTaskDone(item) && !isTaskDeleted(item),
        onSelect: async (item, component) => {
            //console.log("SELECTED prio delayed for", item);
            if (isTaskReminder(item)) return component.delayReminder(item);
            return component.showDialogTaskDelay(item, true);
        },
        isClearable: item => isTaskPostponed(item),
        onClear: async (item, component) => {
            return {
                delayedTill: null
            };
        }
    },
    {
        prio: PRIOS.DEADLINE,
        sort: 15,
        isSortable: true,
        filterType: "overdue",
        label: "Дедлайн",
        labels: "Просроченные",
        title: "Дедлайн просрочен",
        icon: item => isTaskOverdue(item) ? "mdi-timer" : "mdi-timer-outline",
        color: item => isTaskOverdue(item) ? "red" : "grey",
        visibleTo: item => hasFullAccessToTask(item) && isTaskActive(item) && !isTaskNote(item) && !isTaskReminder(item),// && isTaskOverdue(item),
        appliesTo: item => isTaskActive(item) && !isTaskNote(item) && isTaskOverdue(item),
        onSelect: async (item, component) => {
            //console.log("SELECTED prio delayed for", item);
            return component.showDialogTaskDeadline(item, true);
        },
        isClearable: item => !!item.deadline,
        onClear: async (item, component) => {
            return {
                deadline: null
            };
        },
        //sepAfter: true,
    },
    {
        // Устаревший приоритет: объединен с "Важная", в меню и сортировке больше не показывается
        prio: PRIOS.URGENT,
        isSuitableForSubcontent: true,
        isSortable: false,
        label: "Срочная",
        labels: "Срочные",
        icon: "mdi-fire",
        color: "red",
        visibleTo: item => false,
        appliesTo: item => false,   // обрабатывается записью "Важная"
    },
    {
        sep: true,
        prio: PRIOS.IMPORTANT,
        isSuitableForSubcontent: true,
        isSortable: true,
        label: "Важная",
        labels: "Важные",
        icon: "mdi-circle-medium",  //mdi-flag-outline
        color: "red",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskOverdue(item) && !isTaskReminder(item),
        // Срочные и "в фокусе" задачи считаются важными (до завершения миграции данных в БД)
        appliesTo: item => [PRIOS.IMPORTANT, PRIOS.URGENT, PRIOS.FOCUS].includes(item.prio) && isTaskActive(item) && !isTaskNote(item) && !item.isFolder,
        // дополнительные кнопки справа от пункта меню; forceParams передаются в onSelectPrio() как есть
        subButtons: [
            {
                label: "На самый верх",
                icon: "mdi-arrow-up-thin",
                forceParams: {prio: PRIOS.IMPORTANT, withPrepend: true},
                // не показываем, если задача уже первая среди важных
                appliesTo: (item, component) => {
                    if (!component?.siblings) return true;
                    return !isFirstInPrioBucket(item, component.siblings, prioEntryOf(PRIOS.IMPORTANT));
                },
            },
        ],
    },
    {
        // Устаревший приоритет: объединен с "Важная", в меню и сортировке больше не показывается
        prio: PRIOS.FOCUS,
        isSuitableForSubcontent: true,
        isSortable: false,
        label: "В фокусе",
        labels: "В фокусе",
        icon: "mdi-circle-medium",
        color: "red",
        visibleTo: item => false,
        appliesTo: item => false,   // обрабатывается записью "Важная"
    },
    {
        prio: PRIOS.NORMAL,
        isSuitableForSubcontent: true,
        isSortable: true,
        label: "Обычная",
        labels: "Обычная",
        //icon: "mdi-radiobox-indeterminate-variant",
        icon: "mdi-circle-small",
        color: "grey lighten-1",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskOverdue(item) && !isTaskReminder(item),
        appliesTo: item => (!item.prio || item.prio === PRIOS.NORMAL) && isTaskActive(item) && !isTaskNote(item) && !item.isFolder,
        subButtons: [
            {
                label: "Поднять наверх",
                icon: "mdi-arrow-up-thin",
                forceParams: {prio: PRIOS.NORMAL, withPrepend: true},
                appliesTo: (item, component) => {
                    const important = prioEntryOf(PRIOS.IMPORTANT);
                    // важная задача: кнопка не нужна
                    if (important.appliesTo(item)) return false;
                    if (!component?.siblings) return true;
                    // не показываем, если задача уже первая среди обычных
                    return !isFirstInPrioBucket(item, component.siblings, prioEntryOf(PRIOS.NORMAL));
                },
            },
        ],
    },
    {
        sep: true,
        prio: PRIOS.NOTE,
        isSuitableForSubcontent: true,
        isSortable: true,
        //sep: true,
        label: "Заметка",
        labels: "Заметки",
        icon: "mdi-note-outline",
        color: "blue",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskOverdue(item) && !isTaskReminder(item),
        appliesTo: item => isTaskNote(item) && isTaskActive(item) && !item.isFolder,
        onSelect: async (item) => {
            console.log("SELECTED prio note for", item);
            return {
                isNote: !isTaskNote(item)
            };
        }
    },
    {
        // папка: в сортировке не участвует (позиция задаётся только индексом), выбрана у любой папки независимо от prio
        prio: PRIOS.FOLDER,
        isSuitableForSubcontent: true,
        //isSortable: true, // папки не образуют корзину в сортировке
        label: "Папка",
        labels: "Папки",
        icon: "mdi-folder-outline",
        color: "grey",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskReminder(item) && !isTaskComment(item),
        appliesTo: item => !!item.isFolder && isTaskActive(item),
        onSelect: async (item, component) => {
            const isFolder = !item.isFolder;
            // открытая на странице задача, ставшая папкой, больше не открывается как задача - возвращаемся в её контекст
            if (isFolder && component.isRouteSomeTask && component.task.item?.id === item.id) {
                component.$router.push({name: "context", params: {contextId: component.$route.params?.contextId}});
            }
            return {isFolder};
        }
    },
    {
        prio: PRIOS.COMMENT,
        isSuitableForSubcontent: true,
        isSortable: false,
        //sep: true,
        label: "Комментарий",
        labels: "Комментарии",
        icon: "mdi-comment-outline",
        color: "grey",
        visibleTo: item => !isTaskPostponed(item) && !isTaskDone(item) && !isTaskDeleted(item) && hasFullAccessToTask(item) && item.parent?.id === store.state.page.task.item?.id,
        appliesTo: item => isTaskComment(item) && !isTaskDeleted(item),
        /*onSelect: async (item) => {
            console.log("SELECTED prio comment for", item);
            return {
                //isNote: !isTaskNote(item)
            };
        }*/
    },
    {
        //sep: true,
        prio: PRIOS.HIDDEN,
        isPickable: false,
        isSuitableForSubcontent: true,
        label: item => isTaskHidden(item) ? "Показать" : "Скрыть",
        labels: "Скрыты",
        icon: item => isTaskHidden(item) ? "mdi-eye-outline" : "mdi-eye-off-outline",
        color: "blue",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskComment(item),
        appliesTo: () => false,
        //checked: item => isTaskHidden(item),
        onSelect: async (item) => {
            return {
                isHidden: !isTaskHidden(item)
            };
        }
    },
    {
        prio: PRIOS.DELETED,
        isSortable: true,
        filterType: "deleted",
        label: "Удалить",
        labels: "Удаленные",
        icon: item=> isTaskComment(item) ? "mdi-comment-off-outline" : "mdi-trash-can-outline",
        color: "grey",
        visibleTo: item => hasFullAccessToTask(item) && !isTaskReminder(item),
        appliesTo: item => isTaskDeleted(item),
        onSelect: async (item, component) => {
            //console.log("SELECTED prio deleted for", item);
            /*return component.deleteTask(item);
            return true;*/
            return {
                //deletedAt: isTaskDeleted(item) ? null : date2Iso(new Date()),
                deletedAt: date2Iso(new Date()),
            };
        }
    },
    /*{
        label: "Шаг",
        labels: "Шаги",
        icon: (item) => {
            //console.log("SORT TYPE", store.state.page.context.item?.sortType);
            //if (store.state.page.context.item?.sortType === SORT_TYPES.SMART) return "mdi-arrow-right-top";
            return "mdi-arrow-right-bottom"
        },
        color: "grey",
        prio: null,
        visibleTo: item => false,
        appliesTo: item => item.isStage,
        /!*onClick: async (item) => {
            console.log("ON CLICK STAGE", item.parent);
            if (item.parentId) {
                //await router.push({name: "task", params: {taskId: item.parentId}});
                routeToTaskContext(item);
            }
            return false;
        }*!//!*,
        onSelect: async (item) => {
            console.log("ON SELECT STAGE", item.parent);
            if ( item.parent ) {
                await router.push({name: "task", params: {taskId: item.parent.id}});
            }
            return false;
        }*!/
    },*/
];

export const folderPrios = [
    {
        label: "Вернуть",
        labels: "Вернуть",
        icon: "mdi-folder-outline",
        color: "grey",
        prio: null,
        visibleTo: item => isTaskDeleted(item),
        appliesTo: item => false,
        onSelect: async (item) => {
            return {
                doneAt: null,
                delayedTill: null,
                deferredAt: null,
                deletedAt: null,
            }
        }
    },
    {
        sep: true,
        label: "Удалить",
        labels: "Удаленные",
        icon: "mdi-trash-can-outline",
        color: "grey",
        prio: PRIOS.DELETED,
        visibleTo: item => true,
        appliesTo: item => isTaskDeleted(item),
        onSelect: async (item, component) => {
            //console.log("SELECTED prio deleted for", item);
            await component.deleteTask(item);
            return true;
            /*return {
                deletedAt: isTaskDeleted(item) ? null : date2Iso(new Date()),
            };*/
        }
    },
    /*{
        sep: true,
        label: "Удаленная",
        labels: "Удаленные",
        icon: "mdi-trash-can-outline",
        color: "grey",
        prio: null,
        visibleTo: item => isTaskPostponed(item) || isTaskDone(item) || isTaskDeleted(item),
        appliesTo: item => false,
        /!*onClick: async (item) => {
            console.log("ON CLICK STAGE", item.parent);
            if (item.parentId) {
                //await router.push({name: "task", params: {taskId: item.parentId}});
                routeToTaskContext(item);
            }
            return false;
        },*!/
        onSelect: async (item) => {
            return {
                doneAt: null,
                delayedTill: null,
                deferredAt: null,
                deletedAt: null,
            }
        }
    },*/
];

export const deadlines = [
    {
        label: "Наступил",
        icon: "mdi-fire",
        color: "error",
        value: "passed",
    },
    {
        label: "Сегодня",
        icon: "mdi-fire",
        color: "warning",
        value: 0,
    },
    {
        label: "Сегодня или завтра",
        icon: "mdi-fire",
        color: "warning",
        value: 1,
    },
    {
        label: "В ближайшие 2 дня",
        icon: "mdi-fire",
        color: "warning",
        value: 2,
    },
    {
        label: "На этой неделе",
        icon: "mdi-fire",
        color: "warning",
        value: "week",
    },
    {
        label: "В ближайшие 2 недели",
        icon: "mdi-fire",
        color: "warning",
        value: "2-weeks",
    },
];

export const delays = [
    {
        label: "На завтра",
        value: 1,
    },
    {
        label: "На ближайшие 2 дня",
        value: 2,
    },
    {
        label: "На эту неделю",
        value: "week",
    },
    {
        label: "На ближайшие 2 недели",
        value: "2-weeks",
    },
];

export const topicTaskSyncedProps = [
    ///"name",
    "userId",
    "ownerId",
    //deadline: item.deadline,
    "prio",
    "color",
    "doneAt",
    "delayedTill",
    "isDelayed",
];

export const folderIMViews = [
    {value: "task", text: "как задача", icon: "mdi-circle-small"},
    {value: "folder", text: "как папка", icon: "mdi-folder-outline"},
    {value: null, text: "все ее подзадачи", icon: "mdi-dots-grid"},
    {value: "first", text: "первая ее подзадача", icon: "mdi-numeric-1-box-outline"},
    {value: "none", text: "не отображается", icon: "mdi-close"},
];

export const MODES = {
    LIST: "list", // single level list
    HISTORY: "history", // we show date label between tasks
    TREE: "tree",   // full tree list (dnd available)
    NOTIFICATIONS: "notifications",   // no tasks, but notifications
};

/**
 * Russian language cases.
 * @type {{R: string, D: string}}
 */
export const RU_CASES = {
    R: "r",
    D: "d",
}

export const prioColorOf = (item, component) => {
    const prioItem = prios.find(el => el.appliesTo(item, component));
    if (!prioItem) return "grey";
    if (typeof prioItem.color == "function") return prioItem.color(item, component);
    return prioItem.color;
}

export const prioIconOf = (item, component) => {
    const prioItem = prios.find(el => el.appliesTo(item, component));
    if (!prioItem) return "mdi-timer-outline";
    if (typeof prioItem.icon == "function") return prioItem.icon(item, component);
    return prioItem.icon;
}

/**
 * Возвращает первый параграф из текста описания задачи, очищенный от тэгов.
 * @param name
 * @returns {string|*}
 */
export const clearName = (name, keepTags = []) => {
    if (typeof name !== "string") return "";

    const ps = findPs(name);
    //console.log("PS", ps);
    if (ps?.length) name = ps[0];

    // remove html tags
    name = striptags(name, keepTags);

    // remove hashtags
    //name = name.replace(/(^|\s|>)#[^<\s$]+/ig, "$1").trim();

    // remove html entities
    name = name.replace(/\&nbsp\;/ig, " ").trim();

    //if (name.length > 128) name = name.substr(0, 128) + "...";

    return name.trim();
}

export const clearText = (name) => {
    if (!name) return "";

    // remove html tags
    name = striptags(name);

    // remove hashtags
    //name = name.replace(/(^|\s|>)#[^<\s$]+/ig, "$1").trim();

    // remove html entities
    name = name.replace(/\&nbsp\;/ig, " ").trim();

    //if (name.length > 128) name = name.substr(0, 128) + "...";

    return name.trim();
}

export const what = (task, ruCase) => {
    if (task?.isFolder) {
        if (ruCase === RU_CASES.R) return "папку";
        if (ruCase === RU_CASES.D) return "папке";
        return "папка";
    } else if (task?.isNote) {
        if (ruCase === RU_CASES.R) return "заметку";
        if (ruCase === RU_CASES.D) return "заметке";
        return "заметка";
    }
    if (ruCase === RU_CASES.R) return "задачу";
    if (ruCase === RU_CASES.D) return "задаче";
    return "задача";
}

export const titleFromContent = (content) => {
    if (!content) return content || "";

    const ps = findPs(content);
    if (ps?.length < 1) return undefined;
    content = ps[0];

    // remove html tags
    content = striptags(content);

    // remove hashtags
    //name = name.replace(/(^|\s|>)#[^<\s$]+/ig, "$1").trim();

    // remove html entities
    content = content.replace(/\&nbsp\;/ig, " ").trim();

    //if (name.length > 128) name = name.substr(0, 128) + "...";

    return content.trim();
}

export const previewFromContent = (content) => {
    if (!content) return undefined;

    const ps = findPs(content);
    if (ps?.length < 2) return undefined;

    content = ps[1];
    if (!content) return undefined;

    // remove html tags
    content = striptags(content);

    // remove hashtags
    //name = name.replace(/(^|\s|>)#[^<\s$]+/ig, "$1").trim();

    // remove html entities
    content = content.replace(/\&nbsp\;/ig, " ").trim();

    //if (name.length > 128) name = name.substr(0, 128) + "...";

    return content.trim();
}

/**
 * @deprecated - use parentsOf from utils.js
 * @param item
 * @param items
 * @returns {*[]|null}
 */
export const parentsOfIn = (item, items) => {
    const parents = [];
    const findParentOf = (item) => {
        const parent = items.find(el => el.id === item.todoId);
        if (parent) {
            //console.log("parent of " + item.name + ": " + parent.name);
            findParentOf(parent);
            parents.push(parent);
        }
        //else console.log("no parent of " + item.name);
    }
    findParentOf(item);
    return parents.length ? parents : null;
}

export const childrenOf = (items, item) => {
    const children = [];
    const findChildrenOf = (item) => {
        const child = items.find(el => el.todoId === item.id);
        if (child) {
            //console.log("parent of " + item.name + ": " + parent.name);
            children.push(child);
            findChildrenOf(child);
        }
        //else console.log("no parent of " + item.name);
    }
    findChildrenOf(item);
    return children.length ? children : null;
}

export const actualItemsFrom = (items, todoSort, tabName) => {
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const now = new Date().valueOf();
    return sortedItems(items

        // filter out children of undone parents
        .filter(el => {
            if (el.todoId) {
                const parents = parentsOfIn(el, items);
                //if (el.auth === "KvTc88lSXYM0VsRN") console.log("parents", parents);
                // has all parents done?
                return !parents || parents?.reduce((all, item) => all && !!item.doneAt, true);
            }
            return true;
        })

        .filter(el => !el.isTemplate && !el.isPersonal)
        .filter(el => !el.delayedTill && !el.isDelayed)
        /*.filter(el => {
            // ignore minuses if there are active non-minus tags
            if (this.activeTags.find(el => !el.isMinus)) return true;
            // remove inactive minus-tagged, but not with prio
            if (el.prio) return true;
            return !this.tagsOf(el).some(text => {
                const tag = this.tags.find(tag => tag.name === text);
                return tag?.isMinus && !tag.active;
            });
        })*/
        .filter(el => {
            // add done today items
            if (!el.doneAt) return true;
            if (el.isDone) return true;
            const d = iso2Date(el.doneAt).valueOf();
            const days = Math.floor((now - d) / millisecondsPerDay);
            return days <= 0;
        }), todoSort, tabName)

        // filter out done parents of done items
        .filter(el => {
            if (el.doneAt || el.isDone) {
                //console.log("TASK "+el.name+" DONE");
                const doneChild = items.find(child => child.todoId === el.id);
                //console.log("\thas done child", doneChild);
                return !doneChild || !doneChild.doneAt;
            }
            return true;
        });
};

/**
 * Sort items *at place* by a provided list of props.
 * Should be same as on front.
 * @param items - array o f items to be sorted
 * @param neededOrder - a list of props in needed order
 * @param prop - a prop name by which sorting is done
 * @returns {*}
 */
export const sortAccordingTo = (items, neededOrder, prop = 'id') => {
    if (!items) return;
    if (!neededOrder) return;
    const indexes = {};
    const indexOfAuth = (auth) => {
        let index = 9999999999;//-1;
        if (indexes[auth]) index = indexes[auth];
        else if (Array.isArray(neededOrder)) index = indexes[auth] = neededOrder.findIndex(el => el === auth);
        return index;
    }
    items.sort((a, b) => {
        const aIndex = indexOfAuth(a[prop]);
        //console.log("A. "+a.auth+": "+aIndex);
        const bIndex = indexOfAuth(b[prop]);
        //console.log("B. "+b.auth+": "+bIndex);
        return aIndex - bIndex;
    });
}

/**
 * Should be same as on backend.
 * @deprecated
 * @param items
 * @param todoSort
 * @param tabName
 * @param force
 * @returns {*}
 */
export const sortedItems = (items, todoSort, tabName, userId = null, force = false) => {
    const indexes = {};
    const indexOfId = (id) => {
        let index = -1;
        if (indexes['id' + id]) index = indexes['id' + id];
        else if (Array.isArray(todoSort[tabName])) index = indexes['id' + id] = todoSort[tabName].findIndex(el => el === id);
        else if (Array.isArray(todoSort)) index = indexes['id' + id] = todoSort.findIndex(el => el === id);
        return index;
    }
    return items?.sort((a, b) => {
        //флаги, баги, текущие, тесты, выполненные сегодня

        //if ( a.sort !== null && b != null) return a - b;

        if (force) {
            if (userId) {
                if (a.userId === userId && b.userId !== userId) return -1;
                if (a.userId !== userId && b.userId === userId) return 1;
            }

            if (!a.doneAt && b.doneAt) return -1;
            if (a.doneAt && !b.doneAt) return 1;

            if (!a.delayedTill && b.delayedTill) return -1;
            if (a.delayedTill && !b.delayedTill) return 1;

            if (!a.isDelayed && b.isDelayed) return -1;
            if (a.isDelayed && !b.isDelayed) return 1;

            if (a.prio && !b.prio) return -1;
            if (!a.prio && b.prio) return 1;
        }

        // take group sorting
        //tabIndex = tabIndex || 0;
        //const tabName = TAB_NAMES[tabIndex];
        //console.log("todoSort", todoSort, tabName);

        if (todoSort) {
            const aIndex = indexOfId(a.id);
            const bIndex = indexOfId(b.id);
            //if (aIndex < 0 && bIndex >= 0) return -1;
            //if (aIndex >= 0 && bIndex < 0) return 1;
            return aIndex - bIndex;
        }

        if (a.updatedAt > b.updatedAt) return -1;
        if (a.updatedAt < b.updatedAt) return 1;

        /*if (a.createdAt && !b.createdAt) return -1;
        if (!a.createdAt && b.createdAt) return 1;
        if (a.createdAt > b.createdAt) return -1;
        if (a.createdAt < b.createdAt) return 1;*/

        return 0;
    });
};

/**
 * Сортирует items функцией sortFn так, чтобы папки (isFolder) остались на своих местах: папки не участвуют
 * в сортировке по prio и определяются только индексом (позицией в массиве). Как Utils.sortExceptFolders() на backend.
 * sortFn получает массив без папок и сортирует его на месте.
 * @param items
 * @param sortFn
 */
const sortExceptFolders = (items, sortFn) => {
    const folderAt = new Map();
    items.forEach((el, i) => {
        if (el.isFolder) folderAt.set(i, el);
    });
    const rest = items.filter(el => !el.isFolder);
    sortFn(rest);

    let r = 0;
    for (let i = 0; i < items.length; i++) {
        items[i] = folderAt.has(i) ? folderAt.get(i) : rest[r++];
    }
};

/**
 * @deprecated - sorting should not be used on FE
 * Should be same as on backend.
 * @param items
 * @param isDesc
 * @returns {boolean}
 */
export const sortBySmart = (items, isDesc = false) => {
    if (!Array.isArray(items)) return false;
    if (!items.length) return false;

    // папки в сортировке не участвуют - остаются на своих местах (по индексу)
    if (items.some(el => el.isFolder)) {
        sortExceptFolders(items, rest => sortBySmart(rest, isDesc));
        return;
    }

    const nowIso = date2Mysql(new Date());
    items.sort((a, b) => {

        // activity
        if (a.isActive && !b.isActive) return -1;
        if (b.isActive && !a.isActive) return 1;

        // deadline
        if (a.deadline && a.deadline < nowIso && (!b.deadline || b.deadline > a.deadline)) return -1;
        if (b.deadline && b.deadline < nowIso && (!a.deadline || a.deadline > b.deadline)) return 1;

        // prio
        const prioA = Number(a.prio);
        const prioB = Number(b.prio);
        if (prioA !== prioB) return prioB - prioA;
        /*if (prioA > 0 && prioB > 0) return prioA - prioB;
        if (prioA > 0 && prioB <= 0) return -1;
        if (prioA <= 0 && prioB > 0) return 1;
        if (prioA === 0 && prioB < 0) return -1;
        if (prioA < 0 && prioB === 0) return 1;*/

        // папок здесь нет: они исключены из сортировки (sortExceptFolders)

        // index
        return a.index - b.index;
    });
    if (isDesc) items.reverse();
};

/**
 * Basic and fastest sorting - according to server side indexes.
 * @param items
 * @param isDesc
 * @returns {boolean}
 */
export const sortByIndex = (items, isDesc = false) => {
    if (!Array.isArray(items)) return false;
    if (!items.length) return false;
    items.sort((a, b) => a.index - b.index);
    if (isDesc) items.reverse();
};

/**
 * @deprecated - sorting should not be used on FE
 * @param items
 * @param userId
 * @param isDesc
 * @returns {boolean}
 */
export const sortByPrio = (items, userId = null, isDesc = false) => {
    if (!Array.isArray(items)) return false;
    if (!items.length) return false;

    const mapBefore = md5(items.map(el => el.auth));

    // папки в сортировке не участвуют - остаются на своих местах (по индексу)
    if (items.some(el => el.isFolder)) {
        sortExceptFolders(items, rest => sortByPrio(rest, userId, isDesc));
        return md5(items.map(el => el.auth)) !== mapBefore;
    }
    //console.log("MAP BEFORE", items.map(el=>el.auth));

    const currentSorting = items.map(el => el.id);
    const indexes = {};
    const indexOfId = (id) => {
        if (typeof indexes['id' + id] != "undefined") return indexes['id' + id];
        indexes['id' + id] = currentSorting.findIndex(el => el === id);
        return indexes['id' + id];
    }

    const nowIso = date2Mysql(new Date());
    items.sort((a, b) => {

        if (a.isActive && !b.isActive) return -1;
        if (b.isActive && !a.isActive) return 1;

        if (a.deadline && a.deadline < nowIso && (!b.deadline || b.deadline > a.deadline)) return -1;
        if (b.deadline && b.deadline < nowIso && (!a.deadline || a.deadline > b.deadline)) return 1;

        /*if ( a.isActive && b.isActive ) {
            if (a.deadline && a.deadline < nowIso && (!b.deadline || b.deadline > nowIso)) return -1;
            if (b.deadline && b.deadline < nowIso && (!a.deadline || a.deadline > nowIso)) return 1;
            if (a.deadline && b.deadline && a.deadline < nowIso && b.deadline < nowIso && a.deadline < b.deadline) return -1;
            if (a.deadline && b.deadline && a.deadline < nowIso && b.deadline < nowIso && a.deadline > b.deadline) return -1;
        }*/

        //if (userId && !a.deadline && !b.deadline) {
        if (userId) {
            if (a.userId === userId && b.userId !== userId) return -1;
            if (a.userId !== userId && b.userId === userId) return 1;
        }

        /*if (!a.doneAt && b.doneAt) return -1;
        if (a.doneAt && !b.doneAt) return 1;
        if (!a.isDone && b.isDone) return -1;
        if (a.isDone && !b.isDone) return 1;

        if (!a.delayedTill && b.delayedTill) return -1;
        if (a.delayedTill && !b.delayedTill) return 1;

        if (!a.isDelayed && b.isDelayed) return -1;
        if (a.isDelayed && !b.isDelayed) return 1;*/

        const prioA = Number(a.prio);
        const prioB = Number(b.prio);
        if (prioA !== prioB) return prioB - prioA;
        // при равном приоритете назначенные задачи идут выше неназначенных (как в backend Utils.sortByPrio)
        if (a.userId && !b.userId) return -1;
        if (!a.userId && b.userId) return 1;
        /*if (prioA > 0 && prioB > 0) return prioA - prioB;
        if (prioA > 0 && prioB <= 0) return -1;
        if (prioA <= 0 && prioB > 0) return 1;
        if (prioA === 0 && prioB < 0) return -1;
        if (prioA < 0 && prioB === 0) return 1;*/

        // папки сортируются как обычные задачи - по prio
        /*if (!a.isFolder && b.isFolder) return -1;
        if (a.isFolder && !b.isFolder) return 1;*/

        // sort by current position
        const aIndex = indexOfId(a.id);
        const bIndex = indexOfId(b.id);
        return aIndex - bIndex;

        // this sorting should now gone
        //if (a.updatedAt > b.updatedAt) return -1;
        //if (a.updatedAt < b.updatedAt) return 1;

        /*if (a.createdAt && !b.createdAt) return -1;
        if (!a.createdAt && b.createdAt) return 1;
        if (a.createdAt > b.createdAt) return -1;
        if (a.createdAt < b.createdAt) return 1;*/

        return 0;
    });
    if (isDesc) items.reverse();

    //console.log("MAP AFTER", items.map(el=>el.auth));
    const mapAfter = md5(items.map(el => el.auth));
    return mapAfter !== mapBefore;
};

export const sortByUpdated = (items, isDesc = false) => {
    if (!items?.length) return;

    items.sort((a, b) => {

        //if (!a.isFolder && b.isFolder) return -1;
        //if (a.isFolder && !b.isFolder) return 1;

        if (a.updatedAt && !b.updatedAt) return -1;
        if (!a.updatedAt && b.updatedAt) return 1;
        if (a.updatedAt > b.updatedAt) return -1;
        if (a.updatedAt < b.updatedAt) return 1;

        return 0;
    });
    if (isDesc) items.reverse();
};

export const sortByDeleted = (items, isDesc = false) => {
    if (!items?.length) return;

    items.sort((a, b) => {

        //if (!a.isFolder && b.isFolder) return -1;
        //if (a.isFolder && !b.isFolder) return 1;

        if (a.deletedAt && !b.deletedAt) return -1;
        if (!a.deletedAt && b.deletedAt) return 1;
        if (a.deletedAt > b.deletedAt) return -1;
        if (a.deletedAt < b.deletedAt) return 1;

        return 0;
    });
    if (isDesc) items.reverse();
};

export const sortByAlphabet = (items, isDesc = false) => {
    if (!items?.length) return;
    items.sort((a, b) => {

        // папки сортируются как обычные задачи
        /*if (!a.isFolder && b.isFolder) return -1;
        if (a.isFolder && !b.isFolder) return 1;*/

        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;

        return 0;
    });
    if (isDesc) items.reverse();
};

/**
 * @deprecated use sortByPrio/sortByUpdated/sortByAlphabet
 * Should be same as on backend.
 * See Todo.sortByPrio
 * TODO rename to sortByPrio.
 * @param items
 * @param userId
 * @param isDesc
 * @returns {boolean}
 */
export const sortItems = (items, userId = null, isDesc = false) => {
    if (!Array.isArray(items)) return false;
    if (!items.length) return false;

    const mapBefore = md5(items.map(el => el.auth));

    // папки в сортировке не участвуют - остаются на своих местах (по индексу)
    if (items.some(el => el.isFolder)) {
        sortExceptFolders(items, rest => sortItems(rest, userId, isDesc));
        return md5(items.map(el => el.auth)) !== mapBefore;
    }
    //console.log("MAP BEFORE", items.map(el=>el.auth));

    const currentSorting = items.map(el => el.id);
    const indexes = {};
    const indexOfId = (id) => {
        if (typeof indexes['id' + id] != "undefined") return indexes['id' + id];
        indexes['id' + id] = currentSorting.findIndex(el => el === id);
        return indexes['id' + id];
    }

    const nowIso = date2Mysql(new Date());
    items.sort((a, b) => {

        if (a.isActive && !b.isActive) return -1;
        if (b.isActive && !a.isActive) return 1;

        if (a.deadline && a.deadline < nowIso && (!b.deadline || b.deadline > a.deadline)) return -1;
        if (b.deadline && b.deadline < nowIso && (!a.deadline || a.deadline > b.deadline)) return 1;

        /*if ( a.isActive && b.isActive ) {
            if (a.deadline && a.deadline < nowIso && (!b.deadline || b.deadline > nowIso)) return -1;
            if (b.deadline && b.deadline < nowIso && (!a.deadline || a.deadline > nowIso)) return 1;
            if (a.deadline && b.deadline && a.deadline < nowIso && b.deadline < nowIso && a.deadline < b.deadline) return -1;
            if (a.deadline && b.deadline && a.deadline < nowIso && b.deadline < nowIso && a.deadline > b.deadline) return -1;
        }*/

        //if (userId && !a.deadline && !b.deadline) {
        if (userId) {
            if (a.userId === userId && b.userId !== userId) return -1;
            if (a.userId !== userId && b.userId === userId) return 1;
        }

        /*if (!a.doneAt && b.doneAt) return -1;
        if (a.doneAt && !b.doneAt) return 1;
        if (!a.isDone && b.isDone) return -1;
        if (a.isDone && !b.isDone) return 1;

        if (!a.delayedTill && b.delayedTill) return -1;
        if (a.delayedTill && !b.delayedTill) return 1;

        if (!a.isDelayed && b.isDelayed) return -1;
        if (a.isDelayed && !b.isDelayed) return 1;*/

        const prioA = Number(a.prio);
        const prioB = Number(b.prio);
        if (prioA > 0 && prioB > 0) return prioA - prioB;
        if (prioA > 0 && prioB <= 0) return -1;
        if (prioA <= 0 && prioB > 0) return 1;
        if (prioA === 0 && prioB < 0) return -1;
        if (prioA < 0 && prioB === 0) return 1;

        // sort by current position
        const aIndex = indexOfId(a.id);
        const bIndex = indexOfId(b.id);
        return aIndex - bIndex;

        // this sorting should now gone
        //if (a.updatedAt > b.updatedAt) return -1;
        //if (a.updatedAt < b.updatedAt) return 1;

        /*if (a.createdAt && !b.createdAt) return -1;
        if (!a.createdAt && b.createdAt) return 1;
        if (a.createdAt > b.createdAt) return -1;
        if (a.createdAt < b.createdAt) return 1;*/

        return 0;
    });
    if (isDesc) items.reverse();

    //console.log("MAP AFTER", items.map(el=>el.auth));
    const mapAfter = md5(items.map(el => el.auth));
    return mapAfter !== mapBefore;
};

export const prioFromText = (orignalText, originalPrio) => {
    const text = clearText(orignalText);
    if (!text) return undefined;

    let prio = undefined;

    const title = clearName(orignalText);
    //console.log("TITLE", title);
    if (title.match(/!!!/)) prio = PRIOS.IMPORTANT;
    else if (title.match(/!!1/)) prio = PRIOS.IMPORTANT;
    else if (title.match(/!!2/)) prio = PRIOS.IMPORTANT;
    else if (title.match(/!!3/)) prio = PRIOS.IMPORTANT;
    else if (title.match(/!!4/)) prio = PRIOS.NORMAL;
    else if (title.match(/!!5/)) prio = PRIOS.NORMAL;
    else if (title.match(/!!/)) prio = PRIOS.IMPORTANT;   //2
    /*else {
        //if ( originalPrio > 0 ) prio = 0;

        //console.log("TITLE PRIO NO FOUND");

        // check whole text against !![1-5]
        const prioMatches = text.matchAll(/!![1-5]/mg);
        [...prioMatches].forEach(m => {
            m = m[0];
            if (m.match(/!!1/)) prio = 1;
            else if (m.match(/!!2/) && (prio <= 0 || prio > 2)) prio = 2;
            else if (m.match(/!!3/) && prio <= 0) prio = 3;
            else if (m.match(/!!4/) && (prio < 0 || prio === null)) prio = 0;
            else if (m.match(/!!0/) && (prio < 0 || prio === null)) prio = 0;
            else if (m.match(/!!5/) && prio === null) prio = -1;
            console.log("MATCH: " + m + ":" + prio);
        });
    }*/

    /*console.log("ORIGINAL PRIO: " + originalPrio);
    console.log("PRIO FROM TEXT: " + prio);
    console.log("FINAL PRIO: " + prio);*/
    if (typeof prio != "undefined" && prio !== originalPrio) return prio;
    return undefined;
};

export const tagsFromText = (text) => {
    text = striptags(text, [], '\n');
    const matches = [...text.matchAll(/(\s|^)#([\wа-я-_]+)/igs)];
    return matches.map(el => el[2]).filter(el => !!el.trim().toLowerCase());
}

export const deadlineTextAndCss = (task) => {
    let text, css = "blue--text", color = "blue";
    if (isTaskWithDeadlineDays(task)) {
        if (!task.deadlineDays) return {
            text: "Установить дедлайн",
            css: "grey--text text--lighten-1",
            color: "grey",
        };
        if (task.deadlineDays === 7) text = "+1 неделя";
        else if (task.deadlineDays === 14) text = "+2 недели";
        else text = "+" + task.deadlineDays
                + " " + end(task.deadlineDays, "день", "дня", "дней");
        return {
            text: "Дедлайн устанавливается в " + text,
            color: "warning",
        };
    }

    if (!task?.deadline) return {
        text: "Установить дедлайн",
        css: "grey--text text--lighten-1",
        color: "grey",
    }

    const now = new Date();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    const date = iso2Date(task.deadline);
    const diffTime = Math.floor(date / 1000) - Math.floor(now / 1000);
    //console.log("DATE", task.id + "!!"+task.deadline + ":" + now);
    const diffDays = Math.floor(diffTime / (60 * 60 * 24));
    //console.log("diffTime", diffTime);
    //console.log("diffDays", diffDays);
    if (diffDays === 0) {
        text = "сегодня";
        css = "warning--text";
        color = "warning";
    } else if (diffDays === 1) {
        text = "завтра";
        css = "warning--text";
        color = "warning";
    } else if (diffDays === 2) {
        text = "послезавтра";
        css = "warning--text";
        color = "warning";
    } else if (diffDays >= 3 && diffDays < 7) {
        text = "через " + diffDays + " " + end(diffDays, "день", "дня", "дней");
    } else if (diffDays === 7) {
        text = "через неделю";
    } else if (diffDays > 7) {
        text = iso2DDMMYYYY(task.deadline);
    } else if (diffDays === -1) {
        text = "просрочен вчера";
        css = "error--text";
        color = "error";
    } else if (diffDays === -2) {
        text = "просрочен позавчера";
        css = "error--text";
        color = "error";
    } else if (diffDays <= -3 && diffDays > -7) {
        text = "просрочен " + (-diffDays) + " " + end(-diffDays, "день", "дня", "дней") + " назад";
        css = "error--text";
        color = "error";
    } else if (diffDays === -7) {
        text = "просрочен неделю назад";
        css = "error--text";
        color = "error";
    } else if (diffDays < -7) {
        text = iso2DDMMYYYY(task.deadline);
        css = "error--text";
        color = "error";
    }

    return {
        text: "Дедлайн " + text,
        css,
        color
    }
};

export const delayedTillText = (item) => {
    let text = "";
    if (item.delayedTill) {
        let hm = iso2HHMM(item.delayedTill);
        if (hm === "00:00") hm = "";
        else hm = " " + hm;
        text = "до " + iso2DDMMYYYY(item.delayedTill) + hm;
    }
    return text;
}

export const isTaskNew = (item) => {
    if (!item) return false;
    return !!item.bellTill;
};
export const isTaskReminder = (item) => {
    return item?.prio === PRIOS.REMINDER;
};
export const isTaskAccessRequest = (item) => {
    return isTaskReminder(item) && !!item.accessRequestByUserId;
};
export const isTaskOverdue = (item) => {
    if (!item) return false;
    if (item.isNote) return false;
    if (!item.deadline) return false;
    //const date = iso2Date(item.deadline);
    //date.setDate(date.getDate() + 1);
    const now = new Date();
    return item.deadline < date2Mysql(now);
};
export const isTaskOfMyAttention = (item) => {
    if (!item) return false;
    const user = store.state.session.user;
    return isTaskActive(item)
        && (
            item.userId === user.id
            || (isTaskOverdue(item)
                && (item.ownerId === user.id
                    || (!item.ownerId && item.creatorId === user.id))
            )
        );
};
export const isTaskDeleted = (item) => {
    return !!item?.deletedAt;
};
export const isTaskDone = (item) => {
    return !!item?.doneAt;
};
export const isTaskStageItemDone = (stageItem) => {
    return !!stageItem?.stageDoneAt;
};
export const isTopicDone = (item) => {
    if (!item) return false;
    return !!(item.doneAt);
};
/*export const is1TaskInactive = (item) => {
    if (!item) return false;
    if (store.state.session.isAnon) return false;
    return isTaskInactive(item)
        || !isTaskOfMyAttention(item);
};*/
/**
 * Is specified task inactive for specified context?
 * @param context
 * @param item
 * @returns {*}
 */
export const isContextTaskInactive = (context, item) => {
    if (store.state.session.isAnon) return false;
    context = context || store.state.page.context.item;
    if (!context || !item) return false;
    // 1task = isDone | isDelayed | is not mine
    if (context.is1Task) {
        //console.log("CONTEXT", context.isPick, context.preset);
        if (context.isPick && context.preset === PRESETS.MY) return isTaskInactive(item) || !isTaskOfMyAttention(item);
    }
    // block = isDone
    // rest = isDone
    //return isTaskDone(item);
    return isTaskInactive(item);
};
export const isContextTaskActive = (context, item) => {
    return !isContextTaskInactive(context, item);
};
export const isTaskFullyActive = (item) => {
    //console.group("isTaskFullyActive "+item?.title+":");
    let isActive = true;
    if (item.doneAt || item.deferredAt || item.deletedAt || item.delayedTill /*|| item.isDelayed || data.isTemplate || data.isNote*/) {
        isActive = false;
        //console.log("itself: "+isActive);
    } else {
        const parents = parentsOf(item);
        //console.log("count parents "+parents?.length);
        //console.log("parents", parents);
        if (!parents?.length) isActive = true;
        else isActive = parents.every(p => p.isActive || p.isGroup || p.isUser || p.isPick || p.isTag);
        //console.log("due to parents: "+isActive);
    }
    //console.log("result: "+isActive);
    //console.groupEnd();
    return isActive;
};
export const isTaskTemplate = (item) => {
    return !!item?.isTemplate;
};
/**
 * Повторяющаяся задача: не шаблон, но с заданным repeat - после выполнения снова появляется
 * по repeatAt (в отличие от шаблона, который клонируется).
 */
export const isTaskRepeated = (item) => {
    return !item?.isTemplate && !!item?.repeat;
};
/**
 * Дедлайн задаётся не датой, а числом дней (deadlineDays): у шаблона и у повторяющейся задачи
 */
export const isTaskWithDeadlineDays = (item) => {
    return isTaskTemplate(item) || isTaskRepeated(item);
};
export const isTaskNote = (item) => {
    if (!item) return false;
    return !!item.isNote;
};
export const isTaskComment = (item) => {
    return item.prio === PRIOS.COMMENT;
};
export const isTaskHidden = (item) => {
    return !!item?.isHidden;
};
/**
 * A non-folder task that has children of its own (countChildren>0) and therefore has its
 * own auto-synced Context row on the backend (see Tasks._onAfterSaveSyncContextForComplexTask()).
 * Such tasks should be opened as their own context (their children listed), not as a task
 * inside whatever context they were clicked from.
 */
export const isComplexTask = (item) => {
    return !!item && !item.isFolder && !!item.countChildren;
};
export const isTaskDraft = (item) => {
    return !item.publishedAt;
};
export const isTaskFullDraft = (item) => {
    return !item.publishedAt && !item.firstPublishedAt;
};
export const isTaskDelayed = (item) => {
    if (!item) return false;
    return !!item.isDelayed || !!item.delayedTill;
};
export const isTaskDeferred = (item) => {
    if (!item) return false;
    return !!item.deferredAt;
};
export const isTaskPostponed = (item) => {
    return isTaskDeferred(item) || isTaskDelayed(item);
};
export const isTaskWithLargeContent = (item) => {
    return item.content?.length > 512;
};
export const isContextDelayed = (item) => {
    if (!item) return false;
    return !!item.isDelayed || !!item.delayedTill;
};
export const isTopicDelayed = (item) => {
    if (!item) return false;
    return !!item.isDelayed || !!item.delayedTill;
};
export const isTopicVirtual = (item) => {
    if (!item) return false;
    return !item.threadId;
};
export const isTaskInactive = (item) => {
    return !item.isActive || (typeof item.isContextTaskActive != "undefined" && !item.isContextTaskActive);
};
export const isTaskActive = (item) => {
    return !isTaskInactive(item);
};
export const isTaskTemplateActive = (item) => {
    if (!item) return false;
    return !isTaskDone(item) && item.repeat;
};
export const isEmptyTask = (item) => {
    if (!item) return false;
    //console.log("isEmptyTask prio " + item.id);
    //if (item.prio!==PRIOS.COMMENT&&item.prio!==PRIOS.NORMAL) return false;
    //console.log("isEmptyTask deadline " + item.id);
    if (item.deadline) return false;
    //console.log("isEmptyTask title " + item.id);
    if (item.title) return false;
    //console.log("isEmptyTask content " + item.id);
    if (item.content) {
        let text = item.content;
        //console.log("TEXT", text);
        text = pContent(text);
        //console.log("TEXT2", text);
        if (text.length) return false;
    }
    //console.log("EMPTY!! " + item.id);
    return true;
};
export const isHigherPrio = (prio, higherThanPrio) => {
    if (prio < 0 && higherThanPrio >= 0) return false;
    if (prio > 0 && higherThanPrio <= 0) return true;
    if (prio === 0 && higherThanPrio < 0) return true;
    if (prio === 0 && higherThanPrio > 0) return false;
    if (prio > 0 && higherThanPrio > 0) return prio < higherThanPrio;
    if (prio < 0 && higherThanPrio < 0) return prio > higherThanPrio;
    return false;
};
export const hasFullAccessToTask = (item) => {
    return item?.withFullAccess === true;
};
export const hasSomeAccessToTask = (item) => {
    return item?.withFullAccess === true || item?.withReadonlyAccess === true;
};

/**
 * IMPOARTANT! This is not reactive!
 * @returns {boolean}
 */
export const isRouteContextTask = () => {
    return router.currentRoute.name === "context-task";
};
/**
 * IMPOARTANT! This is not reactive!
 * @returns {boolean}
 */
export const isRouteTask = () => {
    return router.currentRoute.name === "task";
};
/**
 * IMPOARTANT! This is not reactive!
 * @returns {boolean}
 */
export const isRoute1Task = () => {
    return router.currentRoute.name === "1task"
        || router.currentRoute.name === "1task-done";
};
/**
 * IMPOARTANT! This is not reactive!
 * @returns {boolean}
 */
export const isRouteSomeTask = () => {
    return isRouteContextTask() || isRoute1Task() || isRouteTask();
};

export const isRoleAdmin = (role) => {
    // TODO temp
    return true;
    return role === ROLES.ADMINISTRATOR.id || role === ROLES.CREATOR.id;
}

export const openContextIds = (state) => {
    const contextIds = [];
    let v = storage.get(Config.STORAGE_OPEN_CONTEXTS);

    // 1. we take context tasks
    store.state.page.tasks.flatItems?.filter(el => !!v?.includes(el.id))?.forEach(el => contextIds.push(el.id));
    // 2. + children of current task
    store.state.page.task.item?.children?.filter(el => !!v?.includes(el.id))?.forEach(el => contextIds.push(el.id));
    // 3. + always current context
    if (store.state.page.context.item) contextIds.push(store.state.page.context.item.id);

    // 4. панельный режим (роут context-chain): страница не хранит контекст и задачи - они лежат в page.contexts.
    // Передаём контексты цепочки роута и раскрытые задачи их списков, иначе бэкенд не вернёт индексы задач
    // (task/update, task/move...) и панели не пересортируются.
    const route = router.currentRoute;
    if (route?.name === "context-chain") {
        const chainIds = route.params?.contextIdChain?.split(Config.CONTEXT_ID_CHAIN_SEP).filter(el => !!el) || [];
        store.state.page.contexts?.forEach(entry => {
            if (!entry?.item) return;
            if (!chainIds.includes(entry.item.id) && !chainIds.includes(entry.item.auth)) return;
            contextIds.push(entry.item.id);
            flatArray(entry.tasks?.items)?.filter(el => !!v?.includes(el.id)).forEach(el => contextIds.push(el.id));
        });
    }

    return contextIds.filter((el, i) => contextIds.indexOf(el) === i);
}
/**
 * @deprecated not used anymore as we move all this to mutations
 * @param skip
 * @returns {{}}
 */
export const contextParams = (skip) => {
    const params = {};
    if (!skip?.includes("contextId")) params.contextId = store.state.page.context.item?.id;
    if (!skip?.includes("contextIds")) params.contextIds = openContextIds();
    if (!skip?.includes("filter")) params.filter = store.state.page.context.item?.filter;
    return params;
}

/**
 * Returns a filtered list of tasks (from current task list) that belong to the specified context.
 * Eg. we are in a group context - we see all tasks of the group, then tasksOfContext(someTopic) will return a subset of the tasks that belong particularly to someTopic.
 * @param context
 * @returns {null|*}
 */
export const tasksOfContext = (context) => {
    context = context || store.state.page.context.item;
    if (!context) return null;
    if (context.isPick || context.isUser) return store.state.page.tasks.items;
    const {rootContextId, contextId} = parseContextIds(context.contextId);
    return store.state.page.tasks.items?.filter(task => {
        const cs = physicalContextsOfTask(task);
        return !!cs?.find(el => el.contextId === contextId);
    });
}
export const countContextInactiveTasks = (context) => {
    context = context || store.state.page.context.item;
    if (!context) return false;
    return tasksOfContext(context)?.filter(el => isContextTaskInactive(context, el))?.length;
};
export const countContextActiveTasks = (context) => {
    context = context || store.state.page.context.item;
    if (!context) return false;
    return tasksOfContext(context)?.filter(el => isContextTaskActive(context, el))?.length;
};
export const countContextTasks = (context) => {
    return tasksOfContext(context)?.length;
};
/**
 * Returns tasks that are visible in CURRENT context.
 * Visible tasks - those that should be shown if we navigate to this context.
 * Tasks that are NOT visible:
 * 1. tasks that are not first in child 1task/blocked contexts
 * 2. tasks in delayed child contexts
 * @returns {null|*}
 */
export const currentContextVisibleTasks = () => {
    let items = store.state.page.tasks.items;
    if (!items?.length) return items;

    const context = fullContextItem(store.state.page.context.item, store.state.session.area);
    if (context) {
        //console.log("CONTEXT", context);
        //if (!context.is1Task && !context.isBlock) return items;
        //const treeContext = this.contexts.find(el => el.contextId === context.contextId);

        // remove from tasks:
        // 1. not first tasks in 1task/blocked contexts
        // 2. tasks in delayed contexts
        items = items.filter(task => {
            //console.log("Task: " + clearName(task.name));

            // take all contexts of task
            const cs = physicalContextsOfTask(task);
            const taskImmediateContext = cs[cs.length - 1];
            //console.log("\tcontexts: " + cs.map(c => c.name + ":" + (c.is1Task || c.isBlock))+"\n");

            // all task of current context are visible
            if ((taskImmediateContext.contextId === context.contextId)) return true;

            // this is a child context - skip task if:
            // 1. its immediate context is 1task/blocked
            // 2. task is NOT first in its immediate context
            if (taskImmediateContext.isTopic && taskImmediateContext.isBlock) {
                const firstTask = contextFirstVisibleTask(taskImmediateContext);
                return !(firstTask && firstTask.auth !== task.auth);

                // 2. is task in a delayed context?
                return !(isContextDelayed(c) && c.contextId !== context.contextId);
            }

            return true;
        });

        //console.log("ITEMS FILTERED!!!", items.length);
    }
    return items;
};
export const countCurrentContextVisibleTasks = () => {
    return currentContextVisibleTasks()?.length;
};
/*export const countContextDoneTasks = (context) => {
    return tasksOfContext(context)?.filter(el => isContextTaskActive(context, el))?.length;
};
export const countContextUndoneTasks = (context) => {
    return tasksOfContext(context)?.filter(el => !isContextTaskActive(context, el))?.length;
};*/
export const contextHasDelayedTill = (context) => {
    if (!context) return false;
    if (!context.isPick) return false;
    let conds = context.conds;
    if (!conds?.length) return false;

    return !!conds.find(fields => !!fields.find(field => field.key === "delayedTill"));
};
export const groupById = (groupId) => {
    return store.state.session.area.groups?.find(el => el.id === groupId);
}
export const groupByContextId = (contextId) => {
    return store.state.session.area.groups?.find(el => el.contextId === contextId);
}
/**
 * @deprecated broken as groupId is never set
 * @param task
 * @returns {null|*}
 */
export const groupOfTask = (task) => {
    if (!task) return null;
    return store.state.session.area.groups?.find(el => el.id === task.groupId);
}
/**
 * @deprecated broken as topicId is never set
 * @param task
 * @returns {null|*}
 */
export const topicOfTask = (task) => {
    if (!task) return null;
    return store.state.session.area.topics?.find(el => el.id === task.topicId);
}
export const tagsOfTask = (task) => {
    if (!task?.tagIds?.length) return null;
    return store.state.session.area.tags?.filter(el => task?.tagIds.includes(el.id));
}
/**
 * Returns physical contexts of the task [group, topic?].
 * @param task
 * @returns {*[]}
 */
export const physicalContextsOfTask = (task) => {
    const cs = [];
    cs.push(groupOfTask(task));
    const topic = topicOfTask(task);
    if (topic) cs.push(topic);
    return cs;
}
/**
 * Returns first visible task of a context.
 * @param context - if not specified - current context is taken
 * @param offset
 * @returns {null|*}
 */
export const contextFirstVisibleTask = (context = null, offset = -1) => {
    context = context || store.state.page.context.item;
    if (!context) return null;

    //console.log("contextFirstVisibleTask of " + context.name);
    let tasks = tasksOfContext(context);
    if (!tasks?.length) return null;

    const countTasks = countContextActiveTasks(context);
    //console.log("CONTEXT: "+context.name);
    //console.log("COUNT UNDONE TASKS: " + countTasks + " of " + tasks?.length);
    if (countTasks) {
        // find from offset
        let firstTask = tasks.find((el, index) => index > offset && !isContextTaskInactive(context, el));
        // start from beginning
        if (!firstTask) firstTask = tasks.find(el => !isContextTaskInactive(context, el));
        return firstTask;
    }
    return null;
}
/**
 * Navigates to a task without any context.
 * In 1task mode stays on the "1task" route (same task, just merges in extra query params like
 * ai=true) instead of leaving 1task mode for the plain "task" route.
 */
export const routeToTask = (taskOrTaskId, query = undefined) => {
    let taskId;
    if (typeof taskOrTaskId == "object") taskId = taskOrTaskId.id;
    else taskId = taskOrTaskId;
    if (isRoute1Task()) {
        return router.push({
            name: "1task",
            params: {...router.currentRoute.params, taskId, apiless: true},
            query: {...router.currentRoute.query, ...query},
        });
    }
    return router.push({name: "task", params: {taskId}, query});
}
/**
 * @deprecated - uses old task.groupId - should be changed
 * @param task
 * @returns {Promise<Route>}
 */
export const routeToTaskContext = (task) => {
    let contextId;
    const group = groupById(task.groupId);
    if (group) contextId = group.contextId;
    if (contextId) {
        return router.push({name: "context-task", params: {contextId, taskId: task.id}});
    } else routeToPersonalTasks();
}
/**
 * Строит цепочку id контекстов до заданной задачи (не "текущую цепочку контекста" - идёт вверх
 * по .parent аргумента parent / по текущему контексту). Используется как params.contextId
 * для маршрутов context/context-task.
 * @param task
 * @param slice - обрезка цепочки (например, -1, чтобы убрать саму задачу)
 * @param parent
 */
export const contextIdChainFor = (task, slice, parent) => {
    const context = store.state.page.context;
    let contextIdChain = [];
    // 1. родитель, если указан
    if (parent) {
        const id = parent?.auth || parent?.id;

        // виртуальный узел "Без проекта" (дерево задач пользователя) не контекст - в цепочку не попадает
        const parentParents = parentsOf(parent);
        parentParents?.reverse();
        parentParents?.filter(p => !p.isNoGroup).map(p => contextIdChain.push(p.auth || p.id));

        if (!parent.isNoGroup) contextIdChain.push(id);

    } else if (context.item) {
        // 2. текущий контекст и его родители
        if (context.parents?.length) contextIdChain = context.parents.map(x => x.id);
        // не дублируем - шаг 3 ниже сам добавляет task.id, а routeToCurrentContext()
        // вызывает эту функцию с task === context.item
        if (task !== context.item) contextIdChain.push(context.item.id);
    }

    // 3. сама задача
    contextIdChain.push(task.id);
    if (slice) contextIdChain = contextIdChain.slice(0, slice);
    return contextIdChain.join(Config.CONTEXT_ID_CHAIN_SEP);
}
/**
 * Находится ли строка списка внутри процесса: сам контекст страницы - процесс
 * или процессом является любой из предков строки (родитель списка и выше).
 * Нужна, чтобы раскрытый в родительском контексте процесс выглядел так же, как процесс-контекст.
 * @param parent - родитель списка, в котором находится строка
 * @param contextItem - задача текущего контекста страницы
 */
export const hasProcessInChain = (parent, contextItem) => {
    if (contextItem?.isProcess) return true;
    let el = parent;
    // ограничение глубины - защита от циклических ссылок parent
    for (let i = 0; el && i < 50; i++, el = el.parent) {
        if (el.isProcess) return true;
    }
    return false;
}
/**
 * Строит маршрут к контексту (папка/тег/группа/подборка).
 * @param context
 * @param parent - родитель папки/задачи (для построения цепочки контекстов), по умолчанию - текущий контекст
 */
export const routeOfContext = (context, parent) => {
    let query = undefined, contextId = undefined;
    // у задач contextId перезаписывается id родителя (см. applyParentsTo), поэтому берём цепочку
    if (context.isFolder || context.isTask) contextId = contextIdChainFor(context, undefined, parent);
    else if (context.isTag) contextId = context.id;
    else if (context.isGroup || context.isUser) contextId = context.contextId || context.id;
    else {
        // подборка (pick)
        if (context.preset === PRESETS.ONE_TASK) {
            return {name: "1task-start"};
        }

        const rootId = rootContextId(context);
        let rootPick;
        if (rootId) rootPick = store.state.session.area?.picks?.find(el => el.contextId === rootId);
        if (context.isPick || rootPick) {
            const c = rootPick || context;
            if (contextHasDelayedTill(c)) query = {tab: TABS.DELAYED};
        }
        contextId = context.contextId;
    }
    return {name: "context", params: {contextId}, query};
}
/**
 * Строит маршрут к задаче внутри явно заданного контекста.
 * @param context
 * @param task
 */
export const routeOfContextTask = (context, task) => {
    return {name: "context-task", params: {contextId: context.contextId || context.id, taskId: task.id}};
}
/**
 * Строит маршрут к задаче в режиме "1task".
 * @param task
 * @param apiless
 */
export const routeOf1Task = (task, apiless = false) => {
    if (!task) return null;
    return {
        name: "1task",
        params: {taskId: task.id, apiless},
        query: {[Config.QUERY_RANDOM_KEY]: Math.random()}
    };
}
/**
 * Строит контекстно-зависимый маршрут для открытия задачи.
 * Папка, задача с назначаемыми подзадачами (countAssignableChildren>0) или forceFolder
 * открываются как контекст (список только её детей).
 * @param item
 * @param parent
 * @param forceFolder
 * @param forceTask - принудительно открывать как задачу в контексте (ветка context-task), даже для папки/задачи с подзадачами
 */
export const routeOfTask = (item, parent, forceFolder = false, forceTask = false) => {
    if (!item) return null;
    let route;

    if (!forceTask && (item.isFolder || item.countActiveChildren > 0 || forceFolder)) {
        route = {
            name: 'context',
            params: {
                contextId: contextIdChainFor(item, undefined, parent),
            },
        };
    } else if (store.state.page.context.item) {
        route = {
            name: 'context-task',
            params: {
                contextId: contextIdChainFor(item, -1, parent),
                taskId: item.id,
                skipContext: !store.state.ui.isTaskFullscreen	// данные контекста для этого маршрута уже есть
            }
        };
    } else {
        // задача без контекста
        route = {
            name: 'task',
            params: {
                taskId: item.id,
                skipContext: false
            }
        };
    }

    // сохраняем query текущего маршрута
    route.query = {...router.currentRoute.query};

    return route;
}
/**
 * @deprecated - we cancelled stages so far.
 * Builds a route to a task stage item (subtask/comment) depending on the current display mode (1task/task/context-task).
 */
export const routeOfTaskStageItem = (stageItem) => {
    let withRandom = false;
    if (stageItem.isCurrentStage) withRandom = true;
    let contextId;
    const currentContext = store.state.page.context.item;
    if (currentContext) contextId = currentContext.contextId;
    let query;
    if (withRandom) query = {[Config.QUERY_RANDOM_KEY]: Math.random()};

    //console.log("routeOfTaskStageItem", stageItem.contentId);

    //this.commit("uiSetPendingEditor", true);
    if (isRoute1Task()) {
        //console.log("ROUTING TO 1task", task.id);
        return {
            name: "1task",
            params: {
                taskId: stageItem.taskId,
                contentId: stageItem.contentId,
                //apiless,
            },
            query
        };
    } else if (isRouteTask()) {
        //console.log("ROUTING TO specified task", task.id);
        return {
            name: "task",
            params: {
                taskId: stageItem.taskId,
                contentId: stageItem.contentId,
                //apiless,
            },
            query
        };
    } else if (contextId) {
        //console.log("ROUTING TO context-task", contextId, task.id);
        return {
            name: "context-task",
            params: {
                contextId,
                taskId: stageItem.taskId,
                contentId: stageItem.contentId,
                //apiless,
                skipContext: true,
            },
            query
        };
    } else {
        //console.log("ROUTING TO fallback task", task.id);
        return {
            name: "task",
            params: {
                taskId: stageItem.taskId,
                contentId: stageItem.contentId,
                //apiless,
            },
            query
        };
    }
}
/**
 * @deprecated - we cancelled stages so fra.
 * Navigates to a task stage item (subtask/comment).
 */
export const routeToTaskStageItem = (stageItem) => {
    return router.push(routeOfTaskStageItem(stageItem));
}

export const personalGroup = () => {
    return store.state.session.area.groups?.find(el => el.isPersonal);
}
/**
 * Navigates to the user's personal context, or home if there's no personal group.
 */
export const routeToPersonalTasks = () => {
    const personalGroup = store.state.session.area.groups?.find(el => el.isPersonal);
    if (personalGroup) router.push({name: "context", params: {contextId: personalGroup.contextId}});
    else router.push({name: "home"});
}
export const rootContextId = (context) => {
    if (!context) return null;
    if (context.isPick) return null;
    if (context.contextId?.length !== Config.AUTH_LENGTH * 2) return null;
    return context.contextId.substring(0, Config.AUTH_LENGTH);
}
export const parseContextIdChain = (str) => {
    if (!str) return null;
    const ids = str.split(Config.CONTEXT_ID_CHAIN_SEP);
    return {
        ids,
        first: ids[0],
        last: ids[ids.length - 1],
        parents: ids.slice(0, -1),
    };

}

export const applyToTreeOf = (item, value, setter) => {
    //console.log("item"+item.title);
    let v = value;
    if (typeof value == "function") v = value(item);
    if (typeof setter == "function") setter(item, v);
    if (item.children?.length) item.children.forEach(child => applyToTreeOf(child, value, setter));
};

/**
 * Inits property .parent in each item in tree.
 * Traverses the tree downward setting .parent to .children of each item (if any).
 * @param tree
 * @param topParent
 */
export const applyParentsTo = (tree, topParent = null) => {
    if (tree?.length) {
        //const items = flatArray(tree);
        const setParent = (tree, parent) => {
            tree.forEach(el => {
                el.parent = parent;
                // задачи узла "Без проекта" лежат прямо в пользовательском контексте (его id хранит сам узел)
                el.contextId = parent?.isNoGroup ? parent.contextId : parent?.id;
                //console.log("SETTING PARENT "+el.contextId+" for "+el.id);
                if (el.children?.length) setParent(el.children, el);
            });
        }
        setParent(tree, topParent);
    }
};

export const applyToNextOf = (item, value, setter) => {
    const parent = item.parent;
    if (!parent) return;
    const siblings = parent.children;
    //console.log("SIBLINGS", siblings?.map(el=>el.title));
    if (!siblings?.length) return;
    const index = siblings.findIndex(el => el.id === item.id);
    if (index === -1) return;

    const nextSiblings = siblings.slice(index + 1);
    //console.log("NEXT SIBLINGS", nextSiblings?.map(el=>el.title));
    nextSiblings.forEach(child => {
        /*let v = value;
        if (typeof value == "function") v = value(child);
        if (typeof setter == "function") setter(child, v);*/
        applyToTreeOf(child, value, setter);
    });
};

export const applyAreaUpdateFromPayload = (state, payload) => {
    //console.log("applyAreaUpdateFromPayload", payload);
    if (!state) state = store.state;

    let areaUpdate = payload?.areaUpdate || payload?.area;
    if (!areaUpdate) return;
    const params = areaUpdate;
    const area = state.session.area;

    // 1. set area
    Object.keys(params).forEach(key => {
        //console.log("AREA UPDATE: ", key, params[key]);
        Vue.set(area, key, params[key]);
    });

    // 2. init local area vars todo - redesign
    //area.groups?.forEach(el => applyIsArchivedForGroup(el));
    //area.topics?.forEach(el => applyIsArchived(el, true));
    initPicksInArea(area);
    initFavoriteUsersInArea(area);

    // 3. sort contexts by user settings
    const user = state.session.user;
    if (user) {
        // todo move decoding to backend
        //if (typeof user.taskSort === "string") user.taskSort = JSON.parse(user.taskSort);
        //if (typeof user.groupSort === "string") user.groupSort = JSON.parse(user.groupSort);
        if (typeof user.pickSort === "string") user.pickSort = JSON.parse(user.pickSort);
        if (typeof user.favUserSort === "string") user.favUserSort = JSON.parse(user.favUserSort);

        sortByAuth(area.picks, user.pickSort, "contextId");
        sortByAuth(area.favoriteUsers, user.favUserSort, "contextId");
        //sortByActivity(area.groups);
        //sortByAuth(area.groups, user.groupSort);
    }
}

export const applyUserUpdateFromPayload = (state, payload) => {
    console.log("applyUserUpdateFromPayload", payload);
    if (!state) state = store.state;

    let userUpdate = payload?.userUpdate?.user || payload?.user;
    if (!userUpdate) return;
    const params = userUpdate;
    const user = state.session.user;

    // 1. set user
    Object.keys(params).forEach(key => {
        //console.log("USER UPDATE: ", key, params[key]);
        Vue.set(user, key, params[key]);
    });

    // 2. resort contexts by user settings
    if (user) {
        const area = state.session.area;
        sortByAuth(area.picks, user.pickSort, "contextId");
        sortByAuth(area.favoriteUsers, user.favUserSort, "contextId");
    }
}

/**
 * Контексты цепочки (page.contexts) со списками задач: в панельном режиме панели показывают именно эти списки
 * (панель читает page.contexts[index].tasks.items), а не state.page.tasks.
 * @param state
 * @returns {Array}
 */
const chainContextEntriesOf = (state) => (state?.page?.contexts || []).filter(el => !!el?.tasks?.items);

/**
 * Переносит задачи в списках контекстов цепочки (page.contexts) - так же, как taskMove делает это для state.page.tasks.
 * Перестановка в том же контексте только меняет index (список сортируется по index); перенос в другой контекст убирает
 * задачу из списка исходного и добавляет в список целевого контекста.
 * Вызывается до запроса (index - желаемый индекс, оптимистичный показ) и после ответа сервера
 * (index не нужен: индексы придут в taskUpdate.indexes, задача при необходимости берётся из taskUpdate.items).
 * @param state
 * @param moves [{taskId, fromContextId, contextId}]
 * @param index желаемый index задач в целевом контексте или undefined
 * @param payload ответ сервера (необязателен)
 */
export const moveTasksInChainContexts = (state, moves, index, payload) => {
    const entries = chainContextEntriesOf(state);
    if (!entries.length || !moves?.length) return;

    const entryOf = (contextId) => entries.find(el => el.item?.id === contextId || el.item?.contextId === contextId);

    moves.forEach(({taskId, fromContextId, contextId}) => {
        const to = entryOf(contextId);
        if (fromContextId === contextId) {
            // перестановка внутри контекста
            const task = to?.tasks.items.find(el => el.id === taskId);
            if (task && typeof index !== "undefined") Vue.set(task, "index", index);
            return;
        }

        // перенос в другой контекст
        let moved = null;
        const from = entryOf(fromContextId);
        if (from) {
            const i = from.tasks.items.findIndex(el => el.id === taskId);
            if (i >= 0) moved = from.tasks.items.splice(i, 1)[0];
        }
        if (!to || to.tasks.items.some(el => el.id === taskId)) return;

        const task = moved
            ? {...moved}
            : payload?.taskUpdate?.items?.find(el => el.id === taskId && (!el.contextId || el.contextId === contextId));
        if (!task) return;
        task.contextId = contextId;
        const serverIndex = payload?.taskUpdate?.indexes?.find(el => el.taskId === taskId && el.contextId === contextId)?.index;
        if (typeof serverIndex !== "undefined") task.index = serverIndex;
        else if (typeof index !== "undefined") task.index = index;
        applyParentsTo([task], to.item);
        to.tasks.items.push(task);
    });
};

export const applyTaskUpdateFromPayload = (state, payload) => {
    if (!state) state = store.state;
    //console.log("applyTaskUpdateFromPayload", payload);

    let tasks = payload?.taskUpdate?.items;
    if (!tasks && payload?.taskUpdate?.item) {
        tasks = [payload?.taskUpdate?.item];
    }
    //if (!tasks?.length) return;
    //console.log("applyTaskUpdateFromPayload", tasks);

    const update = (item, params, withTitle, isList, withContent) => {
        let shouldReactivate = false, shouldActivate = false, shouldReactivateNext = false;
        Object.keys(params).forEach(key => {
            /*if ( isList && key === "title") {
                console.log("TASK UPDATE: list:" + isList + ", " + key + " = " + params[key], typeof params[key]);
            }*/
            //console.log("TASK STAGE: " + item.stage + " / " + item.activeStage);
            if (key === "content") {
                /*if (withTitle) {
                    Vue.set(item, 'title', titleFromContent(params[key]));
                    Vue.set(item, 'preview', previewFromContent(params[key]));
                }
                if (withContent) {
                    Vue.set(item, 'content', params[key]);
                }*/
                /*Vue.set(item, 'title', titleFromContent(params[key]));
                Vue.set(item, 'preview', previewFromContent(params[key]));*/
                Vue.set(item, 'content', params[key]);
            } else {
                /*if (key === "activeStage") {
                    /!*console.log("UPDATE IN LIST", isList, item.activeStage, item.totalStages);
                    if (item.activeStage >= item.totalStages) {
                        item.doneAt = date2Iso(new Date());
                        item.activeStage = item.totalStages - 1;
                    }*!/
                    if (isList && store.state.page.task.stages?.length >= params.activeStage + 1) {
                        if (item.id === store.state.page.task.item?.id) {
                            item.title = titleFromContent(store.state.page.task.stages[params.activeStage]?.content);
                        }
                    }
                } else */
                if (key === "isDelayed") {
                    shouldReactivate = true;
                    shouldReactivateNext = true;
                } else if (key === "delayedTill") {
                    shouldReactivate = true;
                    shouldReactivateNext = true;
                    item.deferredAt = null;
                } else if (key === "deletedAt") {
                    shouldReactivate = true;
                } else if (key === "doneAt") {
                    // finishing
                    shouldReactivate = true;
                    /*if (params.doneAt && item.activeStage < item.totalStages - 1) {
                        // we should move to next stage instead of finishing
                        console.log("STAGE IS FINISHING");
                        item.activeStage++;
                        item.doneAt = null;
                    }*/
                } else if (key === "deferredAt") {
                    shouldReactivate = true;
                    shouldReactivateNext = true;
                    if (!params.deferredAt) params.deferReason = null;
                } else if (key === "prio") {
                    /*console.log("item.prio: " + item.prio);
                    console.log("params.prio: " + params.prio);
                    console.log("params.prio<>item.prio: " + (+item.prio !== +params.prio));*/
                    if (typeof item.prio != "undefined" && +item.prio !== +params.prio) {
                        //console.log("setting shouldActivate prio");
                        if (item.isNote) Vue.set(item, 'isNote', false);
                        shouldActivate = true;
                        shouldReactivate = true;
                        //prioToBranch = item.prio;
                    }
                } else if (key === "isNote") {
                    if (params.isNote && !item.id) {
                        //console.log("setting shouldActivate isNote");
                        shouldActivate = true;
                        shouldReactivate = true;
                    }
                }

                Vue.set(item, key, params[key]);
            }
        });

        const now = new Date();
        item.updatedAt = date2MysqlFull(now);

        // сюда прилетают только подтверждённые сервером данные - значит элемент, который
        // был показан оптимистично (см. taskCreate() в store/task/mutations.js), теперь
        // синхронизирован с BE и больше не FE-only
        if (item._isOptimistic) Vue.delete(item, '_isOptimistic');

        /*console.log("after update item.doneAt: " + item.doneAt);
        console.log("after update item.deletedAt: " + item.deletedAt);
        console.log("after update item.deferredAt: " + item.deferredAt);
        console.log("after update item.delayedTill: " + item.delayedTill);
        console.log("after update shouldActivate: " + shouldActivate);
        console.log("after update shouldReactivate: " + shouldReactivate);*/

        // determine activity of the item and its children
        if (shouldActivate) {
            if (item.doneAt) Vue.set(item, 'doneAt', null);
            // we allow setting priority while task is delayed
            //if ( item.delayedTill) Vue.set(item, 'delayedTill', null);
            if (item.deferredAt) {
                Vue.set(item, 'deferredAt', null);
                Vue.set(item, 'deferReason', null);
            }
            if (item.deletedAt) Vue.set(item, 'deletedAt', null);
            shouldReactivate = true;
        }

        let updateToCurrentTask = {};
        const setActivity = (item, value) => {
            Vue.set(item, "isActive", value);
            //console.log("isActive: " + value + " for " + item.title);

            // TODO is it needed here?
            if (item.id === store.state.page.task.item?.id) {
                updateToCurrentTask = {
                    isActive: value
                };
            }
        };
        if (shouldReactivate) {
            // reseting isActive to item and all its children
            setActivity(item, isTaskFullyActive(item));
            applyToTreeOf(item, isTaskFullyActive, setActivity);

            // задача - контекст страницы (например, открытый процесс): её дети лежат не в item.children, а в
            // page.tasks.items, поэтому активность списка пересчитываем отдельно (иначе при выполнении процесса
            // его шаги остаются "активными" до перезагрузки)
            if (state.page.context.item === item && state.page.tasks?.items?.length) {
                state.page.tasks.items.forEach(child => {
                    setActivity(child, isTaskFullyActive(child));
                    applyToTreeOf(child, isTaskFullyActive, setActivity);
                });
            }
        }

        return {
            shouldReactivate,
            updateToCurrentTask,
        }
    };
    const updateTaskInTree = (taskId, contextId, params, tree) => {
        const items = flatArray(tree);
        const foundItems = items?.filter(el => el.id === taskId
            && (!contextId || el.contextId === contextId));
        //console.log("\t==found tasks: " + foundItems?.length);
        foundItems?.forEach(item => {
            //const res = update(item, params, item.totalStages === 1 || params.stage === item.activeStage, true);
            //console.log("\t== UPDATING task " + " [" + item.id + "] in context " + contextId, params);
            //console.log("\t== UPDATING task title " + " [" + item.id + "] in context " + contextId, params?.title);
            //console.log("\t== UPDATING task prio " + " [" + item.id + "] in context " + contextId, params?.prio);
            //console.log("\t== UPDATING task index " + " [" + item.id + "] in context " + contextId, params?.index);
            //console.log("\t== UPDATING task isContextTaskActive " + " [" + item.id + "] in context " + contextId, params?.isContextTaskActive);
            update(item, params, true, true);
        });
    }

    // 1. update tasks' props
    //console.log("= UPDATING tasks: " + tasks.length);
    tasks?.forEach(params => {
        const taskId = params.id;
        //console.log("applyTaskUpdateFromPayload id " + taskId, params.topicData);
        if (!taskId) return;

        // 1. update context tasks
        //console.log("== UPDATING task in context tasks", params);
        updateTaskInTree(taskId, null, params, state.page.tasks.items);

        // 1.1. keep the flat lookup list in sync too - otherwise a stale (e.g. optimistically
        // inserted) entry would linger there forever, since nothing else refreshes it by id
        updateTaskInTree(taskId, null, params, state.page.tasks.flatItems);

        // 1.1.1. списки задач контекстов цепочки (панели)
        chainContextEntriesOf(state).forEach(entry => updateTaskInTree(taskId, null, params, entry.tasks.items));

        // 1.2. корневой контекст страницы (и его родители) - это тоже задача, если открыт процесс/папка;
        // он не входит в tasks.items, а передаётся как `parent` дочерним задачам, поэтому без этого
        // шага firstAssignableChild процесса не обновляется и следующий шаг остаётся "слабым"
        [state.page.context.item, ...(state.page.context.parents || [])]
            .filter(el => el?.id === taskId && el !== state.page.task.item)
            .forEach(el => update(el, params, true, true));

        // 1.3. легковесный снимок активного шага процесса (firstAssignableChild) хранит title/userId/deadline шага -
        // синхронизируем его с обновлением самой задачи-шага, иначе строка процесса покажет устаревшего исполнителя
        const syncActiveStep = el => {
            const step = el?.firstAssignableChild;
            if (!step || step.taskId !== taskId) return;
            ["title", "userId", "deadline"].forEach(key => {
                if (key in params) Vue.set(step, key, params[key] ?? undefined);
            });
        };
        flatArray(state.page.tasks.items)?.forEach(syncActiveStep);
        flatArray(state.page.tasks.flatItems)?.forEach(syncActiveStep);
        [state.page.context.item, ...(state.page.context.parents || [])].forEach(syncActiveStep);

        // 2. update current edited task
        if (state.page.task.item?.id) {
            console.log("== UPDATING task in editor",
                (state.page.task.item?.id === taskId),
                (!params.contentId || state.page.task.item?.contentId === params.contentId),
                params.contentId,
                state.page.task.item?.contentId
            );
            // 2.1. update current task itself
            if (state.page.task.item?.id === taskId) {
                // only update content & title if stage is current
                if (!params.contentId || state.page.task.item?.contentId === params.contentId) {
                    const paramsForCurrentTask = {...params};
                    /*if (typeof stage != "undefined" && stage !== state.page.task.item?.stage) {
                        delete paramsForCurrentTask.content;
                        delete paramsForCurrentTask.stage;
                        delete paramsForCurrentTask.stageColor;
                        delete paramsForCurrentTask.stageDoneAt;
                    }*/
                    //console.log("== UPDATING task in editor");
                    update(state.page.task.item, paramsForCurrentTask/*state.page.task.item?.id === taskId ? params : updateToCurrentTask*/);
                    //update(state.page.task.item, (updateToCurrentTask && Object.keys(updateToCurrentTask).length) ? updateToCurrentTask : params);
                } else {
                    //console.log("== UPDATING task in editor without content");
                    const p = {
                        ...params,
                    };
                    delete p.content;
                    delete p.contentId;
                    delete p.title;
                    delete p.preview;
                    delete p.state;
                    delete p.stage;
                    delete p.stageDoneAt;
                    update(state.page.task.item, p);
                }

                // apply comments
                /*if (payload.comments?.items) {
                    state.page.comments.items = payload.comments.items;
                }*/
            }

            // 2.2. update within children of current task
            //console.log("== UPDATING task in child tasks");
            updateTaskInTree(taskId, null, params, state.page.task.children);
            /*if (state.page.task.item?.children?.length) {
                item = state.page.task.item.children.find(el => el.id === taskId);
                if (item) update(item, params, params.stage === item.activeStage);
            }*/

            // 2.3. update stages
            //console.log("== BEFORE UPDATING stages", params.stage, !!params.content);
            if (state.page.task.stages?.length && typeof params.stage != "undefined" && typeof params.content != "undefined") {
                //console.log("== UPDATING stages");
                const stage = params.stage;
                const item = state.page.task.stages?.find((el, index) => el.taskId === taskId && index === stage);
                if (item) update(item, params, true, false, true);
            }

            // 2.4. update related
            const related = state.page.task.related;
            related?.forEach(el => {
                if (el.id === taskId) update(el, params);
            });
        }

        // 2.5. то же для задач панелей с собственными данными (сама задача и её комментарии)
        extraTaskHolders(state).forEach(holder => {
            if (holder.item.id === taskId) {
                const holderParams = {...params};
                if (params.contentId && holder.item.contentId !== params.contentId) {
                    delete holderParams.content;
                    delete holderParams.contentId;
                    delete holderParams.title;
                    delete holderParams.preview;
                }
                update(holder.item, holderParams);
            }
            updateTaskInTree(taskId, null, params, holder.children);
        });
    });

    // 2. update indexes of task in contexts
    const indexes = payload?.taskUpdate?.indexes;
    //console.log("= UPDATING indexes of context tasks: " + indexes?.length);
    indexes?.forEach(el => {
        const params = {index: el.index, isContextTaskActive: el.isContextTaskActive};

        // 1. update context tasks
        updateTaskInTree(el.taskId, el.contextId, params, state.page.tasks.items);
        // списки задач контекстов цепочки (панели)
        chainContextEntriesOf(state).forEach(entry => updateTaskInTree(el.taskId, el.contextId, params, entry.tasks.items));

        // 2. update within children of current task
        if (state.page.task.item?.id) {
            updateTaskInTree(el.taskId, el.contextId, params, state.page.task.children);
        }
        extraTaskHolders(state).forEach(holder => updateTaskInTree(el.taskId, el.contextId, params, holder.children));
    });

    // 3. update task contexts
    const contexts = payload?.taskUpdate?.contexts;
    //console.log("= UPDATING stages: " + stages?.length);
    if (contexts?.length) Vue.set(store.state.page.task, "contexts", contexts);
}

export const applyContextUpdateFromPayload = (state, payload) => {
    console.log("applyContextUpdateFromPayload", payload);
    if (!state) state = store.state;

    let contextUpdate = payload?.contextUpdate || payload?.groupUpdate;
    if (!contextUpdate) return;
    const params = contextUpdate.item;

    let updatedContext;
    const update = (item, params) => {
        updatedContext = item;
        Object.keys(params).forEach(key => {
            //console.log("CONTEXT UPDATE: ", item, key, payload.params[key]);
            Vue.set(item, key, params[key]);
        });

        //if (item.isGroup) applyIsArchivedForGroup(item);
    }

    const area = state.session.area;
    //const contexts = jointContexts(area);

    if (params) {
        // update groups in area
        area.groups?.filter(el => // todo get read of auth & groupId in groups...
            el.id === params.id
            || el.auth === params.auth
            || el.auth === params.contextId
            || el.auth === params.id
            || el.id === params.groupId)?.forEach(item => update(item, params));

        // update picks in area
        area.picks?.filter(el => el.id === params.id)?.forEach(item => update(item, params));

        // update tags in area
        area.tags?.filter(el => el.id === params.id)?.forEach(item => update(item, params));

        // цвет пользователя в списке "Люди" (остальные поля контекста пользователя не трогаем)
        if (params.color !== undefined) {
            area.favoriteUsers?.filter(el => el.contextId === params.id || el.id === params.id)
                ?.forEach(item => Vue.set(item, "color", params.color));
        }

        // todo users and user picks
        //area.favoriteUsers?.filter(el => el.id === params.userId)?.forEach(item => update(item, params));
        //area.user?.filter(el => el.id === params.userId)?.forEach(item => update(item, params));

        // update current context
        if (state.page.context.item) {
            if (state.page.context.item.id === params.id) update(state.page.context.item, params);
        }
    }

    // sort groups in area - independent of item, as e.g. task/update & task/publish only send sort
    if (contextUpdate.sort?.length) {
        sortByAuth(area.groups, contextUpdate.sort, "id");
    }
}

export const appendContextFromPayload = (state, payload) => {
    console.log("appendContextFromPayload", payload);
    if (!state) state = store.state;

    const item = payload?.contextAppend?.item;
    if (!item) return;

    const area = state.session.area;
    let items;
    if (item.isPick) items = area.picks;
    else if (item.isTag) {
        if (!area.tags) Vue.set(area, "tags", []);
        items = area.tags;
    } else if (item.isGroup) {
        if (!area.groups) Vue.set(area, "groups", []);
        items = area.groups;
    }

    // insert item
    if (items?.findIndex(el => el.id === item.id) === -1) {
        if (item.isGroup) insertGroupByActivity(items, item);
        else items.push(item);
        console.log("CONTEXT APPENDED", item);
    }
}

export const appendUserPickFromPayload = (state, payload) => {
    console.log("appendUserPickFromPayload", payload);
    if (!state) state = store.state;

    const item = payload?.appendUserPick;
    if (!item) return;

    const area = state.session.area;
    if (!area.favoriteUsers) Vue.set(area, "favoriteUsers", []);

    // insert item at the end - append only, keeps DB/BE ordering (favUserSort) intact
    if (area.favoriteUsers.findIndex(el => el.id === item.id) === -1) {
        area.favoriteUsers.push(item);
        console.log("USER PICK APPENDED", item);
    }
}

export const removeUserPickFromPayload = (state, payload) => {
    console.log("removeUserPickFromPayload", payload);
    if (!state) state = store.state;

    const item = payload?.removeUserPick;
    if (!item) return;

    const area = state.session.area;
    if (!area.favoriteUsers?.length) return;

    // remove every matching entry, not just the first - a stale duplicate can otherwise
    // survive (e.g. leftover from before append-side de-dup, or a HMR reload mid-session)
    let index;
    while ((index = area.favoriteUsers.findIndex(el => el.id === item.id)) >= 0) {
        area.favoriteUsers.splice(index, 1);
        console.log("USER PICK REMOVED", item);
    }
}

export const applyNotificationUpdateFromPayload = (state, payload) => {
    console.log("applyNotificationUpdateFromPayload", payload);
    if (!state) state = store.state;

    let notificationUpdate = payload?.notificationUpdate;
    if (!notificationUpdate) return;

    const item = notificationUpdate.item;
    let items = notificationUpdate.items;
    if (!item?.id && !items?.length) return;

    items = items || [];
    if (item) items.push(item);

    const update = (item, params) => {
        Object.keys(params).forEach(key => {
            Vue.set(item, key, params[key]);
        });
    }

    // update notifications
    const notifications = state.page.notifications.items;
    if (notifications?.length) {
        console.log("= UPDATING notifications: " + items?.length);
        items.forEach(item => {
            console.log("\t[" + item.id + "]: ", item);
            if (!item?.id) return;
            notifications?.filter(el => el.id === item?.id).forEach(el => update(el, item));
        });
    }
}

export const applyEventUpdateFromPayload = (state, payload) => {
    console.log("applyEventUpdateFromPayload", payload);
    if (!state) state = store.state;

    let eventUpdate = payload?.eventUpdate;
    if (!eventUpdate) return;

    const item = eventUpdate.item;
    let items = eventUpdate.items;
    if (!item?.id && !items?.length) return;

    items = items || [];
    if (item) items.push(item);

    const update = (item, params) => {
        Object.keys(params).forEach(key => {
            Vue.set(item, key, params[key]);
        });
    }

    // update notifications
    const events = state.page.events.items;
    if (events?.length) {
        console.log("= UPDATING events: " + items?.length);
        items.forEach(item => {
            console.log("\t[" + item.id + "]: ", item);
            if (!item?.id) return;
            events?.filter(el => el.id === item?.id).forEach(el => update(el, item));
        });
    }
}

export const appendPayloadWithContextIds = (state, payload) => {
    payload = payload || {};
    // we always take root context! from route!
    //const contextIdChain = store.state.page.context.item?.id;////parseContextIdChain(payload.contextId);
    /*const contextIdChain = parseContextIdChain(router.currentRoute?.params?.contextId);//store.state.page.context.item?.id;////parseContextIdChain(payload.contextId);
    if (contextIdChain) {
        const contextId = contextIdChain.last;
        console.log("contextId", contextId);
        if (contextId) {
            let filter = store.state.ui.contextTasksFilter;
            filter = filter[contextId];//.find(el=>el.contextId === contextId);
            if (filter) {
                //console.log("filter", filter);
                //console.log("appendPayloadWithContextIds", filter);
                if (Object.values(filter).filter(el => !!el).length) {
                    payload.contextTasksFilter = filter;
                }
            }
        }
    }*/
    payload.contextIds = openContextIds(state);

    // дерево пользовательского контекста: задача лежит в своём проекте или папке, а не в контексте пользователя.
    // Передаём эти контексты как в группе - бэкенд вернёт индексы ВСЕХ их задач (siblings тоже),
    // и только тех контекстов, где лежат изменяемые задачи, а не всех проектов дерева
    if (state.page.context.userTree) {
        const taskIds = payload.taskIds || (payload.taskId ? [payload.taskId] : null);
        if (taskIds?.length) {
            state.page.tasks.flatItems
                ?.filter(el => el.contextId && taskIds.includes(el.id))
                .forEach(el => {
                    if (!payload.contextIds.includes(el.contextId)) payload.contextIds.push(el.contextId);
                });
        }
    }
    return payload;
}

/**
 * @deprecated moved to BE
 * @param el
 */
export const applyIsArchivedForGroup = (el) => {
    const now = new Date().valueOf();
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    let isArchived = false;

    const updatedAt = el.updatedAt;
    const archivedAt = el.archivedAt;
    let activityAt = el.activityAt;

    //console.log("Group: "+el.name+": "+el.activityAt + ", ", el.archivedAt);

    // todo make same logic for group - do not update group on background
    //if (isTopic && (!activityAt || updatedAt > activityAt)) activityAt = updatedAt;

    //if (el.id === 58) console.log("Archived? " + el.name + ": " + archivedAt + " <> " + activityAt);
    //console.log("Archived? " + el.id + ": " + archivedAt + " <> " + activityAt);
    if (archivedAt && activityAt && archivedAt > activityAt) isArchived = true;
    else if (archivedAt && !activityAt) isArchived = true;
    else if (activityAt) {
        //if ( el.auth === "8G9la5yHB89~dpIA" ) console.log("activityAt of "+el.name+": "+activityAt);
        const d = activityAt.valueOf();
        const days = Math.floor((now - d) / millisecondsPerDay);
        isArchived = days >= Config.GROUP_AUTO_ARCHIVED_AFTER_DAYS;
    }
    if (!isArchived) Vue.set(el, "archivedAt", null);
    Vue.set(el, "_isArchived", isArchived);
}
